/*=================================================
    summary: 學生作答 組合題下方內容 CompositionContent 單元
             練習 說一說        LUSeqNo: 14             
             練習 寫一寫        LUSeqNo: 18
             練習 小組活動      LUSeqNo: 19
             複習 寫一寫        LUSeqNo: 22
             複習 說一說        LUSeqNo: 23

             Practice Speaking
             Practice Writing Composition
             Practice Activity
             Review Writing Composition
             Review Speaking

    remarks: 000 Tim 2021/12/28 Create  原Jeff寫的 PracticeSpeaking
             001 Tim 2022/01/13 增加 ContentText 圖片 Style Width寫入
             002 Tim 2022/01/14 串接 LanguageChangeHandler 流程
=================================================*/

// 1. 需要事先取得的資料: isDataPrerequisiteGotton
//     這些資料會存在 CachedContext
// GetPrerequisiteDataProcessBegin
//         // 1. History
//         // 2. Temp Answer List
// GetPrerequisiteDataProcessBegin

// richard: 
// 這個LU 使用到的 TestSheet 有包含：1. TextArea, 2. Audio 需要特別說明
// 1. TextArea 需要使用 State 的變數 bind 在 value, 如此才能因為 user 改變內容而即時改變 UI (經由 State 的改變，ReRender)
// 2. Audio, 因為要得到 duration 所以也需要 preload
// 上面兩個需求，我目前的能力只能在 Page Chagned 的時候做到

import React, { useEffect, useState, useRef, useContext } from 'react'
import cssCompositionContent from './CompositionContent.module.scss'
import '../../../../Utils/OldContentInlinClass.css'
import { LUCacheContext, GoToLUSinceActionEnum } from '../../../LearningUnit.js'
import { TestSheetContext } from '../CompositionMain/CompositionMain'
import Card from '../../../LUUtils/Card/Card';
import { CardBackgroundEnum } from '../../../LUUtils/Card/Card';
import { ImageTypeEnum } from '../../../../Tool/ImageDisplayWindow/ImageDisplayWindow.js'
import parse from 'html-react-parser'
import CircularProgress from '@material-ui/core/CircularProgress'
import './CompositionContent.css'
import {GlobalLibs, NetworkLibs, PackageVariablesLibs} from 'bc-react-package'

// #region Constant
const COMP_NAME = "CompositionContent"
const MAX_MESSAGE_CHARACHERS = 1000 // Textarea最大的數字限制
const INIT_PAGE_INDEX = -1
const RETRY_PAGE_INDEX = 101
// const SAVE_PAGE_INDEX = 102 // 2023-08-23 Jeff 修改成 存檔時 不修改CurrentPageIndex 避免不必要的空白頁面
// const SUBMIT_PAGE_INDEX = 103 // 2023-08-23 Jeff 修改成 存檔時 不修改CurrentPageIndex 避免不必要的空白頁面
const IMAGE_DISPLAY_WIDTH = 506
// #endregion Constant

// #region Enumeration
export const TestSheetModeEnum = {
    New: 1,
    Temp: 2,
    History: 3
}

const TagIndexEnum = {
    StudentAnswer: 1,
    TeacherComment: 2,
}

const PlayingStatusEnum = {
    Playing: 2,
    Paused: 3,
    Stop: 4
}

const ScrollButtonEnum = {
    Top: 1,
    More: 2
}

export const ExecuteActionEnum = {
    "Retry": 1,
    "SaveAnswer": 2,
    "SubmitAnswer": 3,
    "UpdateDisplay": 4,
    "RegisterAudioEvent": 5
}
// #endregion Enumeration

// #region Member Variables
let mblnInitialized = false
let mintTotalPages = 0 // 此LU內 若有Multiple Page 則 在此紀錄共有幾個Page
let mstrLUCatSeqNo = ""
let mstrBookCatID = ""
let mstrLUKey4LUCachedContext = "" // 用於從LUCacheContext 取出 Cache的LU資料時 指出此LU時所需的Key
let marrAnswerList4Save = []
let marrAnswerList4Submit = []
let mintImagePickerClickedIndex = -1
let mintGoToLUSinceAction = -1 // 第一次進入LU時 判斷是用點擊/上一頁/下一頁進來的 而給予不同的<Card />動畫
let mintChangeAnimationType = 0 // 0:window.gChangeAnimationTypeEnum.None, 決定Card動畫是 由左而右 或 由右而左
let mintStateTagIndex = TagIndexEnum.StudentAnswer
let mintStateTeacherCommentAudioPlayStatus = PlayingStatusEnum.Stop
let mintStateStudentRecordedAudioPlayStatus = PlayingStatusEnum.Stop
let mintStateCurrentPageIndex = 0 // Index of SubCategory, ListOfContent, SuperQuestion or IlluContents
let mstrImagePrefix = "" // For content of SubCategory, ListOfContent, SuperQuestion or IlluContents
let mstrAudioPrefix = "" // For content of SubCategory, ListOfContent, SuperQuestion or IlluContents
let marrContentData = [] // For content of SubCategory, ListOfContent, SuperQuestion or IlluContents
let mintIndexOfContent4PreloadImage = 0 // 在Preload時 指出來目前是指到 marrContentData[mintIndexOfContent4PreloadImage]
let mintIndexOfContentImage4PreloadImage = 0 // 在Preload時 指出來目前是指到 marrContentData[mintIndexOfContent4PreloadImage].ImageList[mintIndexOfContentImage4PreloadImage]
let mintClassID = -1
// #endregion Member Variables

function CompositionContent(props)
{
    console.log(COMP_NAME + ".Begin:", props)
    console.log(COMP_NAME + ".props.LUInfo: ", props.LUInfo)
    console.log(COMP_NAME + ".props.LessonID: ", props.LessonID)
    console.log(COMP_NAME + ".props.PracticeEnable: ", props.PracticeEnable)

    // #region Init State
    const [currentPageIndex, setCurrentPageIndex] = useState(INIT_PAGE_INDEX)
    const [answerText, setAnswerText] = useState("")
    const [tagIndex, setTagIndex] = useState(TagIndexEnum.StudentAnswer)
    const [updateDataTime, setUpdateDataTime] = useState(0)

    const [studentRecordedAudioPlayingStatus, setStudentRecordedAudioPlayingStatus] = useState(PlayingStatusEnum.Stop) // 音檔的播放狀態
    const [studentRecordedAudioDuration, setStudentRecordedAudioDuration] = useState(0)
    const [studentRecordedAudioCurrentTime, setStudentRecordedAudioCurrentTime] = useState(0)

    const [teacherCommentAudioPlayStatus, setTeacherCommentAudioPlayStatus] = useState(PlayingStatusEnum.Stop) // 音檔的播放狀態
    const [teacherCommentAudioDuration, setTeacherCommentAudioDuration] = useState(0)
    const [teacherCommentAudioCurrentTime, setTeacherCommentAudioCurrentTime] = useState(0)

    const [studentShowMoreButton, setStudentShowMoreButton] = useState(false)
    const [studentMessageHeight, setStudentMessageHeight] = useState(-1)

    const [teacherShowMoreButton, setTeacherShowMoreButton] = useState(false)
    const [teacherMessageHeight, setTeacherMessageHeight] = useState(-1)

    const [showScrollButton, setShowScrollButton] = useState(false) // Top/More按鈕是否顯示
    const [scrollButtonType, setScrollButtonType] = useState(ScrollButtonEnum.More) // 要顯示Top或More
    // #endregion Init State

    // #region Init Ref
    let mrefStudentAnswerMessageArea = useRef(null)
    let mrefStudentAnswerMessageText = useRef(null)
    let mrefTeacherCommentMessageArea = useRef(null)
    let mrefTeacherCommentMessageText = useRef(null)
    // #endregion Init Ref

    // #region Init Function Ref
    let mrefPaintedMe = useRef(null)
    let mrefCleanUp = useRef(null)
    let mrefPageChanged = useRef(null)
    let mrefTabIndexChanged = useRef(null)
    let mrefPreloadAudioAfterHistoryItemSelected = useRef(null)

    mrefPaintedMe.current = PaintedMe
    mrefCleanUp.current = CleanUp
    mrefPageChanged.current = PageChanged
    mrefTabIndexChanged.current = TabIndexChanged
    mrefPreloadAudioAfterHistoryItemSelected.current = PreloadAudioAfterHistoryItemSelected
    // #endregion Init Function Ref

    // #region Init Context Ref
    // History, Temp, 都是 Cached 在這裏
    let mobjLUCacheContext = useContext(LUCacheContext)
    console.log("mobjLUCacheContext: ", mobjLUCacheContext)

    let mobjTestSheetContext = useContext(TestSheetContext)
    console.log("mobjTestSheetContext: ", mobjTestSheetContext)
    // #endregion Init Context Ref

    // #region First Launch
    if (!mblnInitialized)
    {
        console.log(COMP_NAME + ".Begin: mblnInitialized: ", mblnInitialized)

        if (
            (typeof (window.gSession.Acc.Class) !== 'undefined') &&
            (window.gSession.Acc.Class !== null) &&
            (window.gSession.Acc.Class.length > 0) &&
            (window.gSession.Acc.CurrentClassIndex >= 0) &&
            (typeof (window.gSession.Acc.Class[window.gSession.Acc.CurrentClassIndex]) !== 'undefined') &&
            (window.gSession.Acc.Class[window.gSession.Acc.CurrentClassIndex] !== null) &&
            (typeof (window.gSession.Acc.Class[window.gSession.Acc.CurrentClassIndex].ClassID) !== 'undefined') &&
            (window.gSession.Acc.Class[window.gSession.Acc.CurrentClassIndex].ClassID !== null) &&
            (parseInt(window.gSession.Acc.Class[window.gSession.Acc.CurrentClassIndex].ClassID) > 0)
            )
        {
            mintClassID = parseInt(window.gSession.Acc.Class[window.gSession.Acc.CurrentClassIndex].ClassID)
        }
        else
        {
            mintClassID = -1
        }
        mblnInitialized = true
    }
    // #endregion First Launch

    // #region useEffect
    useEffect(() => {
        console.log(COMP_NAME + ".useEffect")
        mrefPaintedMe.current()

        // Similar to componentWillUnmount
        return () => {
            console.log(COMP_NAME + ".cleanup")
            mrefCleanUp.current()
        }
    }, [props.LUInfo])

    useEffect(() => {
        mrefPageChanged.current(currentPageIndex)
    }, [currentPageIndex])

    useEffect(() => {
        mintStateTagIndex = tagIndex
        mrefTabIndexChanged.current(tagIndex)
    }, [tagIndex])

    useEffect(() => {
        mintStateTeacherCommentAudioPlayStatus = teacherCommentAudioPlayStatus
    }, [teacherCommentAudioPlayStatus])

    useEffect(() => {
        mintStateStudentRecordedAudioPlayStatus = studentRecordedAudioPlayingStatus
    }, [studentRecordedAudioPlayingStatus])

    useEffect(() => {
        if (props.Index4HistoryItemToShow !== -1)
        {
            // 訊息More 還原  Tim22.01.25
            setStudentMessageHeight(-1)
            setTeacherMessageHeight(-1)
            mrefPreloadAudioAfterHistoryItemSelected.current()
        }
    }, [props.Index4HistoryItemToShow])
    // #endregion useEffect

    // #region Painted Me
    // 程式進入 
    // 從 Backend 要資料
    // 需要 Open Loading Mask, 所以不要寫在 .Begin, 要寫在 useEffect
    function PaintedMe()
    {
        console.log(COMP_NAME + ".PaintedMe: ")

        RegisterAudioEvent()
        RegisterExecuteCompositionContentAction()
        RegisterLanguageChangeHandler()

        GlobalLibs.AddWindowOnResizeWindow(WindowOnResizeEventHandler, COMP_NAME)

        mstrLUKey4LUCachedContext = "LU" + props.LUInfo.LUCatSeqNo // 用於Cache LU資料時 指出此LU的Key
        mstrBookCatID = window.gSession.App.BookCatID.toString().PadLeft(2)
        mstrLUCatSeqNo = props.LUInfo.LUCatSeqNo
        mstrImagePrefix = window.Globals.GetResourcePrefix(mstrBookCatID, props.LessonID, window.gResourceTypeEnum.Image);
        mstrAudioPrefix = window.Globals.GetResourcePrefix(mstrBookCatID, props.LessonID, window.gResourceTypeEnum.Audio);
        console.log("mstrImagePrefix: ", mstrImagePrefix)
        console.log("mstrAudioPrefix: ", mstrAudioPrefix)
        mintTotalPages = props.LUInfo.SuperQuestion.length

        // 第一次進入LU時 判斷是用點擊/上一頁/下一頁進來的 而給予不同的<Card />動畫
        // richard: 先“紀錄”如何進入 LU
        // 需要在 TestSheet 設定完成之後利用這個值做判斷，決定顯示哪個page
        // 一旦第一次顯示之後，這個值就不再需要了
        mintGoToLUSinceAction = props.GoToLUSinceAction

        // 註冊Multiple Page中的上/下一頁事件
        let objCallbackData = {
            "Action": "InitCalledInfoInMultiPagedLU",
            "NextOnTapHandlerRef": LUNextPageHandler,
            "PrevOnTapHandlerRef": LUPrevPageHandler,
            "CanBePrev": (mintStateCurrentPageIndex > 0), // Multiple Page 非第一頁才為ture 
            "CanBeNext": (mintStateCurrentPageIndex < mintTotalPages - 1) // Multiple Page 非最後一頁才會true
        }
        props.CallbackRef(objCallbackData)

        GoToPageAfterSetTestSheet()

        InitContentDataProcessBegin()
    } // end of PaintedMe

    function CleanUp()
    {
        console.log(COMP_NAME + ".CleanUp: ")

        // 避免離開這個 LU 還收到 Audio Player 的 Callback
        window.AudioLibs.RemoveEventHandlerRef(window.AudioLibs.RegisterEventTypeEnum.AudioEnded)
        window.AudioLibs.RemoveEventHandlerRef(window.AudioLibs.RegisterEventTypeEnum.AudioDurationChanged)
        window.AudioLibs.RemoveEventHandlerRef(window.AudioLibs.RegisterEventTypeEnum.AudioTimeUpdated)

        GlobalLibs.RemoveWindowOnResizeWindow(COMP_NAME)
        window.AudioLibs.StopAudio()
        mintStateCurrentPageIndex = 0 // Reset
        mblnInitialized = false

        // 訊息More 還原  Tim22.01.25
        setStudentMessageHeight(-1)
        setTeacherMessageHeight(-1)
    }
    // #endregion Painted Me

    // #region OnTapHandler
    function ScrollAreaScrollToTopOrMoreOnTapHandler()
    {
        console.log(COMP_NAME + ".ScrollAreaScrollToTopOrMoreOnTapHandler: ")
        // console.log("mrefScrollArea.current: ", mrefScrollArea.current)
        /*
        改用 document.getElementById("divScrollArea") 不用 mrefScrollArea.current 的原因
        
        當 在LU:Language Notes 切換不同分頁 且 不同分頁分別都可Scroll 且 mrefScrollArea放在<Card>裡面 時 e.g. DCP Language Notes Lesson 37 
        則 第二次出現的分頁 其Top/More按鈕觸發的function ScrollAreaScrollToTopOrMoreOnTapHandler中所取得的 mrefScrollArea.current 會變成 null
        解決方法 改用 getElementById 取得此 scroll element

        若 DCP LanguageNotesVocabulary 的 mrefScrollArea 放在 <Card> 外面 則不會有上述的問題 在function ScrollAreaScrollToTopOrMoreOnTapHandler取得的 mrefScrollArea.current 可正確取得
        */
        let objScrollArea = document.getElementById("divScrollArea");
        console.log("objScrollArea: ", objScrollArea)

        if (objScrollArea !== null)
        {

            let intScrollHeight = objScrollArea.scrollHeight; // scrollHeight Ref: https://www.w3schools.com/jsref/prop_element_scrollheight.asp
            let intScrollWidth = objScrollArea.scrollWidth; // scrollWidth
            let intScrollLeft = objScrollArea.scrollLeft; // scrollLeft
            let intScrollTop = objScrollArea.scrollTop; // scrollTop

            console.log("intScrollHeight:", intScrollHeight)
            console.log("intScrollWidth:", intScrollWidth)
            console.log("intScrollLeft:", intScrollLeft)
            console.log("intScrollTop:", intScrollTop)

            let intClientHeight = objScrollArea.clientHeight; // .divScrollArea 的高度 // clientHeight Ref: https://www.w3schools.com/jsref/prop_element_clientheight.asp
            let intClientWidth = objScrollArea.clientWidth; // clientWidth Ref: 
            let intClientTop = objScrollArea.clientTop; // clientTop
            let intClientLeft = objScrollArea.clientLeft; // clientLeft

            console.log("intClientHeight:", intClientHeight)
            console.log("intClientWidth:", intClientWidth)
            console.log("intClientTop:", intClientTop)
            console.log("intClientLeft:", intClientLeft)

            // let intScrollTop = objScrollArea.scrollTop;
            // let intClientHeight = objScrollArea.clientHeight;
            // let intScrollHeight = objScrollArea.scrollHeight;

            // +1 是避免有小數點的誤差
            if (intScrollTop + intClientHeight + 1 >= intScrollHeight )
            {
                console.log("ScrollAreaScrollToTopOrMoreOnTapHandler: Scroll已在最底")
                // 如果現在是在Scroll的最底端 則回到最Top
                // Scroll To Top
                // objScrollArea.scrollTo({ 
                //     top: 0, 
                //     behavior: "smooth" 
                // });
                GlobalLibs.ExecuteScrollTo(objScrollArea, 0, 0, 300)
            }
            else
            {
                console.log("ScrollAreaScrollToTopOrMoreOnTapHandler: Scroll未在最底")
                // 如果未到底 就向下移動 (clientHeight / 2) 如果已到最底 則不動
                // Scroll To Somewhere
                let intScrollTo = objScrollArea.scrollTop + ((intScrollTop + intClientHeight !== intScrollHeight) ? (intClientHeight/ 2) : 0)
                // objScrollArea.scrollTo({ 
                //     top: intScrollTo, 
                //     behavior: "smooth" 
                // });

                GlobalLibs.ExecuteScrollBy(objScrollArea, intScrollTo, 0, 300)
            }

        }
    }

    function HasUploadImageAreaOnTapHandler(ImageUrl, ImageAnsFNKey)
    {
        console.log(COMP_NAME + ".HasUploadImageAreaOnTapHandler: ", ImageUrl, ImageAnsFNKey)
        // 按下後，延遲一下再切換，解決雙擊可能會進入雙層的問題
        if (GlobalLibs.IsClickTooFast())
        {
            return
        }

        let objCallbackData = {
            "Action": "OpenShowImageDisplayWindow",
            "Arguments": {
                "ImageType": ImageTypeEnum.Composition,
                "ImageUrl": ImageUrl
            }
        }
        props.CallbackRef(objCallbackData)
    }

    function StudentMoreOnTapHandler()
    {
        console.log(COMP_NAME + ".StudentMoreOnTapHandler")
        // 按下後，延遲一下再切換，解決雙擊可能會進入雙層的問題
        if (GlobalLibs.IsClickTooFast())
        {
            return
        }

        if (
            (typeof (mrefStudentAnswerMessageText.current) !== 'undefined') &&
            (mrefStudentAnswerMessageText.current !== null) &&
            (typeof (mrefStudentAnswerMessageText.current.clientHeight) !== 'undefined') &&
            (mrefStudentAnswerMessageText.current.clientHeight !== null) &&
            (mrefStudentAnswerMessageText.current.clientHeight > 0)
            )
        {
            setStudentMessageHeight(mrefStudentAnswerMessageText.current.clientHeight)
        }
    }

    function TeacherMoreOnTapHandler()
    {
        console.log(COMP_NAME + ".TeacherMoreOnTapHandler")
        // 按下後，延遲一下再切換，解決雙擊可能會進入雙層的問題
        if (GlobalLibs.IsClickTooFast())
        {
            return
        }

        if (
            (typeof (mrefTeacherCommentMessageText.current) !== 'undefined') &&
            (mrefTeacherCommentMessageText.current !== null) &&
            (typeof (mrefTeacherCommentMessageText.current.clientHeight) !== 'undefined') &&
            (mrefTeacherCommentMessageText.current.clientHeight !== null) &&
            (mrefTeacherCommentMessageText.current.clientHeight > 0)
            )
        {
            setTeacherMessageHeight(mrefTeacherCommentMessageText.current.clientHeight)
        }
    }

    function DeleteImageOnTapHandler(ImageAnsFNKey)
    {
        console.log(COMP_NAME + ".DeleteImageOnTapHandler: ", ImageAnsFNKey)
        // 按下後，延遲一下再切換，解決雙擊可能會進入雙層的問題   Tim15.07.31
        if (GlobalLibs.IsClickTooFast())
        {
            return
        }

        mobjTestSheetContext.AnswerList[currentPageIndex][ImageAnsFNKey] = null

        // Tim 幫忙補上     Tim21.12.30
        mobjTestSheetContext.Dirty = true

        let objCallbackData = {
            "Action": "TestSheetContextDirty"
        }
        props.CallbackRef(objCallbackData)

        setUpdateDataTime(new Date().getTime())
    }

    function ShowAudioRecordingWindowOnTapHandler()
    {
        console.log(COMP_NAME + ".ShowAudioRecordingWindowOnTapHandler: ")
        // 按下後，延遲一下再切換，解決雙擊可能會進入雙層的問題   Tim15.07.31
        if (GlobalLibs.IsClickTooFast())
        {
            return
        }

        let blnCanSupport = true
        if (
            (window.gSession.App.BrowserType4LogTrace === GlobalLibs.BrowserTypeEnum.Edge) ||
            (window.gSession.App.BrowserType4LogTrace === GlobalLibs.BrowserTypeEnum.ChromiumEdge)
            )
        {
            blnCanSupport = false
        } // end of if (window.gSession.App.BrowserType4LogTrace === GlobalLibs.BrowserTypeEnum.ChromiumEdge)

        if (blnCanSupport)
        {
            let objCallbackData = {
                "Action": "AudioRecordingWindowOpen",
                "CallbackRef": AudioRecordingWindowCallback,
            }
            console.log("objCallbackData:", objCallbackData)
            props.CallbackRef(objCallbackData)
        } // end of if (blnCanSupport)
        else
        {
            let objAlertObject = {
                Header: window.gAppUI.MSG_Alert_Title_Google_SR_NotSupport,
                Body: window.gAppUI.MSG_Alert_Msg_Audio_Record_NotSupport,
                ShowCloseButton: false,
                CallbackRef: null,
                Buttons: [
                    {
                        Text: PackageVariablesLibs.UISettings.BTN_OK,
                        AutoFocus: true
                    }
                ]
            }
            ShowAlert(objAlertObject)
        } // end of else
    }

    function PlayStudentRecordedAudioOnTapHandler(AudioUrl, StateStudentRecordedAudioPlayingStatus)
    {
        console.log(COMP_NAME + ".PlayStudentRecordedAudioOnTapHandler: ", AudioUrl, StateStudentRecordedAudioPlayingStatus)
        // 按下後，延遲一下再切換，解決雙擊可能會進入雙層的問題   Tim15.07.31
        if (GlobalLibs.IsClickTooFast())
        {
            return
        }

        if (StateStudentRecordedAudioPlayingStatus === PlayingStatusEnum.Paused)
        {
            setStudentRecordedAudioPlayingStatus(PlayingStatusEnum.Playing)
            window.AudioLibs.Play()
        }
        else if (StateStudentRecordedAudioPlayingStatus === PlayingStatusEnum.Stop)
        {
            setStudentRecordedAudioPlayingStatus(PlayingStatusEnum.Playing)
            window.AudioLibs.PlayAudio(AudioUrl)
        }

        setStudentRecordedAudioCurrentTime(0) // 播放音檔前 先歸0
    }

    function PlayTeacherCommentAudioOnTapHandler(AudioUrl, StateTeacherCommentAudioPlayStatus)
    {
        console.log(COMP_NAME + ".PlayTeacherCommentAudioOnTapHandler: ", AudioUrl, StateTeacherCommentAudioPlayStatus)
        // 按下後，延遲一下再切換，解決雙擊可能會進入雙層的問題
        if (GlobalLibs.IsClickTooFast())
        {
            return
        }

        if (StateTeacherCommentAudioPlayStatus === PlayingStatusEnum.Paused)
        {
            setTeacherCommentAudioPlayStatus(PlayingStatusEnum.Playing)
            window.AudioLibs.Play()
        }
        else if (StateTeacherCommentAudioPlayStatus === PlayingStatusEnum.Stop)
        {
            setTeacherCommentAudioPlayStatus(PlayingStatusEnum.Playing)
            window.AudioLibs.PlayAudio(AudioUrl)
        }
    }

    function StopStudentRecordedAudioOnTapHandler()
    {
        console.log(COMP_NAME + ".StopStudentRecordedAudioOnTapHandler: ")
        // 按下後，延遲一下再切換，解決雙擊可能會進入雙層的問題   Tim15.07.31
        if (GlobalLibs.IsClickTooFast())
        {
            return
        }

        setStudentRecordedAudioPlayingStatus(PlayingStatusEnum.Stop)
        setStudentRecordedAudioCurrentTime(0)
        window.AudioLibs.StopAudio()
    }

    function StopTeacherCommentAudioOnTapHandler()
    {
        console.log(COMP_NAME + ".StopTeacherCommentAudioOnTapHandler: ")
        // 按下後，延遲一下再切換，解決雙擊可能會進入雙層的問題   Tim15.07.31
        if (GlobalLibs.IsClickTooFast())
        {
            return
        }

        setTeacherCommentAudioPlayStatus(PlayingStatusEnum.Stop)
        setTeacherCommentAudioCurrentTime(0)
        window.AudioLibs.StopAudio()
    }

    function PauseStudentRecordedAudioOnTapHandler()
    {
        console.log(COMP_NAME + ".PauseStudentRecordedAudioOnTapHandler: ")
        // 按下後，延遲一下再切換，解決雙擊可能會進入雙層的問題   Tim15.07.31
        if (GlobalLibs.IsClickTooFast())
        {
            return
        }

        setStudentRecordedAudioPlayingStatus(PlayingStatusEnum.Paused)
        window.AudioLibs.PauseAudio()
    }

    function PauseTeacherCommentAudioOnTapHandler()
    {
        console.log(COMP_NAME + ".PauseTeacherCommentAudioOnTapHandler: ")
        // 按下後，延遲一下再切換，解決雙擊可能會進入雙層的問題   Tim15.07.31
        if (GlobalLibs.IsClickTooFast())
        {
            return
        }

        setTeacherCommentAudioPlayStatus(PlayingStatusEnum.Paused)
        window.AudioLibs.PauseAudio()
    }

    function DeleteAudioOnTapHandler()
    {
        console.log(COMP_NAME + ".DeleteAudioOnTapHandler: ")
        // 按下後，延遲一下再切換，解決雙擊可能會進入雙層的問題   Tim15.07.31
        if (GlobalLibs.IsClickTooFast())
        {
            return
        }

        mobjTestSheetContext.AnswerList[mintStateCurrentPageIndex].RecordedAnsFN = null
        mobjTestSheetContext.Dirty = true

        let objCallbackData = {
            "Action": "TestSheetContextDirty"
        }
        props.CallbackRef(objCallbackData)

        setUpdateDataTime(new Date().getTime())
    }

    function ClearAnswerOnTapHandler()
    {
        console.log(COMP_NAME + ".ClearAnswerOnTapHandler")
        // 按下後，延遲一下再切換，解決雙擊可能會進入雙層的問題   Tim15.07.31
        if (GlobalLibs.IsClickTooFast())
        {
            return
        }

        let objAnswer = mobjTestSheetContext.AnswerList[mintStateCurrentPageIndex]
        console.log("objAnswer: ", JSON.parse(JSON.stringify(objAnswer)))
        objAnswer.CompositionAns = null
        objAnswer.ImageAns01FN = null
        objAnswer.ImageAns02FN = null
        objAnswer.ImageAns03FN = null
        objAnswer.RecordedAnsFN = null

        console.log("objAnswer: ", mobjTestSheetContext.AnswerList[mintStateCurrentPageIndex])
        setAnswerText("")

        // Tim 幫忙補上     Tim21.12.30
        mobjTestSheetContext.Dirty = true

        let objCallbackData = {
            "Action": "TestSheetContextDirty"
        }
        props.CallbackRef(objCallbackData)

        setUpdateDataTime(new Date().getTime())
    }

    function TabOnTapHandler(CurrentTagIndex)
    {
        console.log(COMP_NAME + ".TabOnTapHandler: ", CurrentTagIndex)
        // 按下後，延遲一下再切換，解決雙擊可能會進入雙層的問題   Tim15.07.31
        if (GlobalLibs.IsClickTooFast())
        {
            return
        }

        if (CurrentTagIndex === TagIndexEnum.StudentAnswer)
        {
            setTeacherMessageHeight(-1)
            // Student Answer
            setTagIndex(TagIndexEnum.StudentAnswer)
        }
        else if (CurrentTagIndex === TagIndexEnum.TeacherComment)
        {
            setStudentMessageHeight(-1)
            // Teacher Comment
            setTagIndex(TagIndexEnum.TeacherComment)
        }

        SetMoreButtonForMessage()
    }

    function TeacherCommentVideoPlayOnTapHandler(VideoUrl)
    {
        console.log(COMP_NAME + ".TeacherCommentVideoPlayOnTapHandler: ", VideoUrl)

        // 按下後，延遲一下再切換，解決雙擊可能會進入雙層的問題
        if (GlobalLibs.IsClickTooFast())
        {
            return
        }

        setTeacherCommentAudioPlayStatus(PlayingStatusEnum.Stop)
        setTeacherCommentAudioCurrentTime(0)
        window.AudioLibs.StopAudio()

        // setAnswerAudioStatus(window.gAudioStatusEnum.Stop)

        // import TeachersFeedback from '../../Resources/Images/VideoPosters/TeachersFeedback.png'
        // import TeachersFeedbackMin from '../../Resources/Images/VideoPosters/TeachersFeedbackMin.png'

        // let strPosterFN = "TeachersFeedback";
        // if (
        //     (!window.gSession.App.InApp) || 
        //     (window.devicePixelRatio < 2)
        //     )
        // {
        //     strPosterFN += "Min";
        // }
        // strPosterFN += ".png";
        // let strPosterUrl = "../../../Resources/Images/VideoPosters/" + strPosterFN
        let strPosterUrl = ""

        let objCallbackData = {
            "Action": "OpenShowViderPlayerWindow",
            "Arguments": {
                "Title": "",
                "VideoUrl": VideoUrl,
                "PosterUrl": strPosterUrl
            }
        }
        console.log("objCallbackData:", objCallbackData)
        props.CallbackRef(objCallbackData)
    }
    // #endregion OnTapHandler

    // #region Other Handler

    function ScrollAreaScrollEventHandler(e)
    {
        console.log(COMP_NAME + ".ScrollAreaScrollEventHandler");

        let elmnt = e.target;

        let intScrollHeight = elmnt.scrollHeight; // scrollHeight Ref: https://www.w3schools.com/jsref/prop_element_scrollheight.asp
        let intScrollWidth = elmnt.scrollWidth; // scrollWidth
        let intScrollLeft = elmnt.scrollLeft; // scrollLeft
        let intScrollTop = elmnt.scrollTop; // scrollTop

        console.log("intScrollHeight:", intScrollHeight)
        console.log("intScrollWidth:", intScrollWidth)
        console.log("intScrollLeft:", intScrollLeft)
        console.log("intScrollTop:", intScrollTop)

        let intClientHeight = elmnt.clientHeight; // .divScrollArea 的高度 // clientHeight Ref: https://www.w3schools.com/jsref/prop_element_clientheight.asp
        let intClientWidth = elmnt.clientWidth; // clientWidth Ref: 
        let intClientTop = elmnt.clientTop; // clientTop
        let intClientLeft = elmnt.clientLeft; // clientLeft

        console.log("intClientHeight:", intClientHeight)
        console.log("intClientWidth:", intClientWidth)
        console.log("intClientTop:", intClientTop)
        console.log("intClientLeft:", intClientLeft)

        if (intScrollTop === 0)
        {
            console.log('Reached scroll div top')
        }

        // +1 是避免有小數點的誤差
        if (intScrollTop + intClientHeight + 1 >= intScrollHeight )
        {
            // 目前到最底 則切換 Top/Down圖示

            console.log('Reached scroll div bottom')
            setScrollButtonType(ScrollButtonEnum.Top)
        }
        else
        {
            setScrollButtonType(ScrollButtonEnum.More)
        }
    }

    function RegisterAudioEvent()
    {
        console.log(COMP_NAME + ".RegisterAudioEvent")

        window.AudioLibs.RegisterEventHandlerRef(PlayAudioEndHandler, window.AudioLibs.RegisterEventTypeEnum.AudioEnded)
        window.AudioLibs.RegisterEventHandlerRef(AudioDurationChangedHandler, window.AudioLibs.RegisterEventTypeEnum.AudioDurationChanged)
        window.AudioLibs.RegisterEventHandlerRef(AudioTimeUpdatedHandler, window.AudioLibs.RegisterEventTypeEnum.AudioTimeUpdated)
    }

    function WindowOnResizeEventHandler()
    {
        console.log(COMP_NAME + ".WindowOnResizeEventHandler")

        SetMoreButtonForMessage()
        SetScrollToTopOrMoreButton()
    }

    function LUPrevPageHandler()
    {
        console.log(COMP_NAME + ".LUPrevPageHandler: ")

        console.log("mintStateCurrentPageIndex: ", mintStateCurrentPageIndex)
        console.log("mintTotalPages: ", mintTotalPages)

        // Stop audio
        window.AudioLibs.StopAudio()
        ResetStudentAnswerAndTeacherCommentAudioStatus()

        if (mintStateCurrentPageIndex > 0)
        {
            // 目前在Multiple Page中 的非第一頁 點擊上一頁
            console.log("Prev is clicked, let's go to Prev page")
            if(mobjTestSheetContext.Dirty)
            {
                // Multiple Page 內部換頁的時候 要自動Save
                let objCallbackData = {
                    "Action": "SaveAnswer"
                }
                props.CallbackRef(objCallbackData)
            }

            mintChangeAnimationType = window.gChangeAnimationTypeEnum.Prev // 動畫新的畫面 由右往左出現
            let intPageIndex = mintStateCurrentPageIndex - 1
            setCurrentPageIndex(intPageIndex)

            let objCallbackData = {
                "Action": "UpdateCanBeNavigatedInMultiPagedLU",
                "CanBePrev": (intPageIndex > 0),
                "CanBeNext": (intPageIndex < mintTotalPages - 1)
            }
            props.CallbackRef(objCallbackData)

            ScrollToTop()
        }
        else
        {
            // richard: 20211110 因為有 CanBeNext, parent 加判斷就不會發生
            // LU內有Multiple Page中 已在第一頁時 點擊上一頁
            console.log("Prev is clicked in the 1st page, let's inform parent")
            console.log("不應該發生")
        }
    }

    function LUNextPageHandler()
    {
        console.log(COMP_NAME + ".LUNextPageHandler: ")

        console.log("mintStateCurrentPageIndex: ", mintStateCurrentPageIndex)
        console.log("currentPageIndex: ", currentPageIndex)
        console.log("mintTotalPages: ", mintTotalPages)

        // Stop audio
        window.AudioLibs.StopAudio()
        ResetStudentAnswerAndTeacherCommentAudioStatus()

        if (mintStateCurrentPageIndex < mintTotalPages - 1)
        {
            // LU內有Multiple Page 在非最後一頁時 點擊下一頁
            console.log("Next is clicked, let's go to next page")

            if(mobjTestSheetContext.Dirty)
            {
                // Multiple Page 內部換頁的時候 要自動Save
                let objCallbackData = {
                    "Action": "SaveAnswer"
                }
                props.CallbackRef(objCallbackData)
            }

            mintChangeAnimationType = window.gChangeAnimationTypeEnum.Next // 動畫新的畫面 由左往右出現
            let intPageIndex = mintStateCurrentPageIndex + 1
            setCurrentPageIndex(intPageIndex)

            let objCallbackData = {
                "Action": "UpdateCanBeNavigatedInMultiPagedLU",
                "CanBePrev": (intPageIndex > 0),
                "CanBeNext": (intPageIndex < mintTotalPages - 1)
            }
            props.CallbackRef(objCallbackData)

            ScrollToTop()
        }
        else
        {
            // richard: 20211110 因為有 CanBeNext, parent 加判斷就不會發生
            console.log("Next is clicked in the last page, let's inform parent")
            console.log("不應該發生")
        }
    }

    // #region Audio Event Handler

    function AudioDurationChangedHandler(Duration)
    {
        console.log(COMP_NAME + ".AudioDurationChangedHandler: ", Duration)

        if (mintStateTagIndex === TagIndexEnum.StudentAnswer)
        {
            setStudentRecordedAudioDuration(Duration)
        }
        else if (mintStateTagIndex === TagIndexEnum.TeacherComment)
        {
            setTeacherCommentAudioDuration(Duration)
        }
    }

    function AudioTimeUpdatedHandler(CurrentTime)
    {
        console.log(COMP_NAME + ".AudioTimeUpdatedHandler: ", CurrentTime)

        console.log("studentRecordedAudioCurrentTime: ", studentRecordedAudioCurrentTime)
        console.log("CurrentTime: ", CurrentTime)

        console.log("teacherCommentAudioDuration: ", teacherCommentAudioDuration)

        if (mintStateTagIndex === TagIndexEnum.StudentAnswer)
        {
            if (
                (mintStateStudentRecordedAudioPlayStatus === PlayingStatusEnum.Playing) &&
                (Math.ceil(studentRecordedAudioCurrentTime) !== Math.ceil(CurrentTime))
                )
            {
                setStudentRecordedAudioCurrentTime(CurrentTime)
            }
        }
        else if (mintStateTagIndex === TagIndexEnum.TeacherComment)
        {
            if (
                (mintStateTeacherCommentAudioPlayStatus === PlayingStatusEnum.Playing) &&
                (Math.ceil(teacherCommentAudioDuration) !== Math.ceil(CurrentTime))
                )
            {
                setTeacherCommentAudioCurrentTime(CurrentTime)
            }
        }
    }

    function PlayAudioEndHandler()
    {
        console.log(COMP_NAME + ".PlayAudioEndHandler: ")

        setStudentRecordedAudioPlayingStatus(PlayingStatusEnum.Stop)
        setTeacherCommentAudioPlayStatus(PlayingStatusEnum.Stop)
    }

    // #endregion Audio Event Handler

    function FilePickerOnChangeHandler(e, ImageInputIndex)
    {
        console.log(COMP_NAME + ".FilePickerOnChangeHandler: ", e, ImageInputIndex)

        mintImagePickerClickedIndex = ImageInputIndex

        console.log("e.target: ", e.target)
        console.log(e.target.files[0])
        // e.target.files[0] is file seleted
        let objFile = e.target.files[0]
        // objFile.type is "image/jpeg" ...

        let objFileReader = new FileReader();
        objFileReader.onload = function (e)
        {
            console.log("file is loaded")
            console.log("e: ", e)
            console.log("e.target.result: ", e.target.result)

            let objArguments = {
                "ImageBase64": e.target.result
            }

            // setImageBase64(e.target.result)
            let objCallbackData = {
                "Action": "ImageEditorWindowOpen",
                "CallbackRef": ImageEditorWindowCallback,
                "Arguments": objArguments
            }
            console.log("objCallbackData:", objCallbackData)
            props.CallbackRef(objCallbackData)
        }
        objFileReader.readAsDataURL(objFile)
    }

    function AnswerTextOnChangeHandler(e)
    {
        console.log(COMP_NAME + ".AnswerTextOnChangeHandler: ", e)
        // console.log(COMP_NAME + ".AnswerTextOnChangeHandler: e.target.value:", e.target.value)

        mobjTestSheetContext.AnswerList[mintStateCurrentPageIndex].CompositionAns = e.target.value
        mobjTestSheetContext.Dirty = true

        console.log("AnswerTextOnChangeHandler.mobjTestSheetContext: ", mobjTestSheetContext)

        setAnswerText(e.target.value)

        let objCallbackData = {
            "Action": "TestSheetContextDirty"
        }
        props.CallbackRef(objCallbackData)
    }

    /*===========================================
    summary: 語言設定 改變 事件
    remarks: 000 Tim 2022/01/14 Create
    ===========================================*/
    function LanguageOnChangeHandler()
    {
        // console.log(COMP_NAME + ".LanguageOnChangeHandler: ")     // Richard 習慣這樣找 Function  Tim22.01.03
        console.log(COMP_NAME + ".LanguageOnChangeHandler BEGIN")
        
        setUpdateDataTime(0)

        InitContentDataProcessBegin()
    } // end of LanguageOnChangeHandler
    // #endregion Other Handler

    // #region LoadingMask and Alert
    function OpenLoadingMask(LoadingMsg)
    {
        console.log("OpenLoadingMask: ", LoadingMsg)

        let objCallbackData = {
            "Action": "OpenLoadingMask",
            "Message": LoadingMsg
        }
        props.CallbackRef(objCallbackData)
    }

    function CloseLoadingMask()
    {
        console.log(COMP_NAME + ".CloseLoadingMask")

        let objCallbackData = {
            "Action": "CloseLoadingMask"
        }
        props.CallbackRef(objCallbackData)
    }

    function ShowAlert(AlertObject)
    {
        let objCallbackData = {
            "Action": "ShowAlertWindow",
            "AlertObject": AlertObject
        }
        props.CallbackRef(objCallbackData)
    }
    // #endregion LoadingMask and Alert

    // #region Toast
    // #endregion Toast

    // #region Component Callback
    function ImageEditorWindowCallback(CallbackObj)
    {
        console.log(COMP_NAME + ".ImageEditorWindowCallback.CallbackObj: ", CallbackObj)

        if (CallbackObj.Action === "ImageEditorWindowCloseWithoutImage")
        {
            console.log("ImageEditorWindowCloseWithoutImage")
        }
        else if (CallbackObj.Action === "ImageEditorWindowCloseWithImage")
        {
            OpenLoadingMask(window.gAppUI.MSG_LoadMask_LoadImage)

            console.log("ImageEditorWindowCloseWithImage")
            console.log("CallbackObj.Arguments.ImageBase64: ", CallbackObj.Arguments.ImageBase64)

            UserImageUploadedGotton(CallbackObj.Arguments.ImageBase64)
            setUpdateDataTime(new Date().getTime())
        }
    }

    function AudioRecordingWindowCallback(CallbackObj)
    {
        console.log(COMP_NAME + ".AudioRecordingWindowCallback.CallbackObj: ", CallbackObj)

        if (CallbackObj.Action === "AudioRecordingWindowCloseWithoutResult")
        {
            console.log("AudioRecordingWindowCloseWithoutResult")
            RegisterAudioEvent() // 因為開啟AudioRecordingWindow時 Audio Event被註冊過去 所以關閉AudioRecordingWindow時 要再註冊回此
        }
        else if (CallbackObj.Action === "AudioRecordingWindowCloseWithResult")
        {
            OpenLoadingMask(window.gAppUI.MSG_LoadMask_LoadAudioData)
            RegisterAudioEvent() // 因為開啟AudioRecordingWindow時 Audio Event被註冊過去 所以關閉AudioRecordingWindow時 要再註冊回此

            console.log("AudioRecordingWindowCloseWithResult")
            console.log("Audio Base64: ", CallbackObj.AudioBase64)
            UserReordedGotton(CallbackObj.AudioBase64)
        }
    }

    function CardCallback(CallbackObj)
    {
        console.log(COMP_NAME + ".CardCallback", CallbackObj)

        if (CallbackObj.Action === "ComponentDidUpdate")
        {
            SetMoreButtonForMessage()
            SetScrollToTopOrMoreButton()
        }
    }
    // #endregion Component Callback

    // #region Other Functions

    function PreloadAudioAfterHistoryItemSelected()
    {
        console.log(COMP_NAME + ".PreloadAudioAfterHistoryItemSelected")

        // Preload audio mobjTestSheetContext
        if (
            (typeof (mobjTestSheetContext) !== 'undefined') &&
            (mobjTestSheetContext !== null) &&
            (typeof (mobjTestSheetContext.AnswerList) !== 'undefined') &&
            (mobjTestSheetContext.AnswerList.length !== 0) &&
            (typeof (mobjTestSheetContext.AnswerList[mintStateCurrentPageIndex]) !== 'undefined')
            )
        {
            setStudentRecordedAudioDuration(0)
            setStudentRecordedAudioCurrentTime(0)

            // Preload audio in page
            let strAudioUrl = mobjTestSheetContext.AnswerList[mintStateCurrentPageIndex].RecordedAnsFN
            if (strAudioUrl !== null)
            {
                console.log("useEffect props.UpdateDataTime changed. Reload StudentRecordedAudioDuration")
                strAudioUrl = GetAudioUrl4Play(mobjTestSheetContext.AnswerList[mintStateCurrentPageIndex].RecordedAnsFN, mobjTestSheetContext.AnswerList[mintStateCurrentPageIndex].AnswerID, mobjTestSheetContext.AssignID, mobjTestSheetContext.Mode)

                window.AudioLibs.PreloadAudio(strAudioUrl)
            }
        }
    }

    /*===========================================
    summary: 初始化 題目內容 流程 開始
    remarks: 000 Tim 2022/01/07 Create
    ===========================================*/
    function InitContentDataProcessBegin()
    {
        console.log(COMP_NAME + ".InitContentDataProcessBegin: ")

        marrContentData = []

        let arrImage = []
        let arrKeywordList = []
        let objContent = null

        /*
        Step 1. 讀取 HtmlContent, 取得 裡面的所有大圖路徑及縮圖路徑放入ImageList
        Step 2. Preload 所有縮圖後 取得其高寬比例後 設定style 讓縮圖可顯示合適的大小
        Step 3. Preload 所有原圖 每讀取完一張原圖 就顯示
        */

        props.LUInfo.SuperQuestion.forEach((SuperQuestionItem) => {
            // Step 1. 讀取 HtmlContent, 取得 裡面的所有大圖路徑及縮圖路徑放入ImageList
            arrKeywordList = (window.gSession.Acc.Preferences.Lang === window.gLangTypeEnum.Major) ? SuperQuestionItem.ContentHTML.MajorLangKeyword : SuperQuestionItem.ContentHTML.MinorLangKeyword
            objContent = window.Globals.CreateContentText(SuperQuestionItem.ContentHTML.Text, arrKeywordList, mstrImagePrefix)

            console.log("objContent: ", objContent)
            console.log("arrImage: ", arrImage)

            marrContentData.push(objContent)
        })

        console.log("marrContentData: ", marrContentData)

        // Step 2. Preload 所有縮圖後 取得其高寬比例後 設定style 讓縮圖可顯示合適的大小
        PreloadThumbnailImageProcessBegin()
    } // end of InitContentDataProcessBegin

    /*===========================================
    summary: 初始化 題目內容 流程 開始
    remarks: 000 Tim 2022/01/07 Create
    ===========================================*/
    function InitContentDataProcessEnd()
    {
        console.log(COMP_NAME + ".InitContentDataProcessEnd: ")

        // 顯示縮圖後 再去Load大圖
        setUpdateDataTime(new Date().getTime())

        // 等setUpdateDataTime(new Date().getTime())產生玩畫面 出現mrefScrollArea後 再去判斷是否顯示Top/More按鈕
        setTimeout(function()
        {
            SetScrollToTopOrMoreButton()
        }, 100)

        // Step 3. 讀取 每一張原圖 每讀取完一張就顯示
        PreloadOriginalImageProcessBegin()
    } // end of InitContentDataProcessEnd


    // #region Preload Original Image
    
    // Preload原圖流程開始
    function PreloadOriginalImageProcessBegin()
    {
        console.log(COMP_NAME + ".PreloadOriginalImageProcessBegin: ")
        console.log("marrContentData: ", marrContentData)
        
        mintIndexOfContent4PreloadImage = 0
        mintIndexOfContentImage4PreloadImage = 0

        if (marrContentData[mintIndexOfContent4PreloadImage].ImageList.length > 0)
        {
            LoadOriginalImage(mintIndexOfContent4PreloadImage, mintIndexOfContentImage4PreloadImage)
        }
        else
        {
            LoadNextOriginalImage(mintIndexOfContent4PreloadImage, mintIndexOfContentImage4PreloadImage)
        }
    }

    // Preload原圖流程結束
    function PreloadOriginalImageProcessEnd()
    {
        console.log(COMP_NAME + ".PreloadOriginalImageProcessEnd: ")

        console.log("PreloadOriginalImageProcessEnd.marrContentData: ", marrContentData)
    }

    // Preload原圖
    function LoadOriginalImage(IndexOfContent, ImgIndex)
    {
        console.log(COMP_NAME + ".LoadOriginalImage: ", IndexOfContent, ImgIndex)

        let objImage = new Image()
        objImage.onload = function ()
        {
            OriginalImageLoadedHandler(IndexOfContent, ImgIndex)
        };

        // 原圖
        objImage.src = marrContentData[IndexOfContent].ImageList[ImgIndex].OriginalImageUrl // 原圖
    }

    // 原圖讀取完成後要做的處理
    function OriginalImageLoadedHandler(IndexOfContent, ImgIndex)
    {
        console.log(COMP_NAME + ".OriginalImageLoadedHandler: ", IndexOfContent, ImgIndex)

        // 避免 OriginalImageLoadedHandler 觸發的時候 已經換到其他頁 導致讀不到資料跳錯
        if(
            (marrContentData.length > 0) &&
            (typeof(marrContentData[IndexOfContent]) !== "undefined") &&
            (marrContentData[IndexOfContent] !== null) &&
            (typeof(marrContentData[IndexOfContent].ImageList) !== "undefined") &&
            (marrContentData[IndexOfContent].ImageList !== null) &&
            (typeof(marrContentData[IndexOfContent].ImageList[ImgIndex]) !== "undefined") &&
            (marrContentData[IndexOfContent].ImageList[ImgIndex] !== null)
            )
        {
            let strOriginalImageUrl = marrContentData[IndexOfContent].ImageList[ImgIndex].OriginalImageUrl
            console.log("strOriginalImageUrl: ", strOriginalImageUrl)
            let strContentText = marrContentData[IndexOfContent].ContentText
            console.log("strContentText: ", strContentText)
            marrContentData[IndexOfContent].ContentText = window.Globals.ChangeThumbnailImageUrlToOriginalImageUrl(strContentText, ImgIndex, strOriginalImageUrl)

            // 原圖每Load完成一張就顯示
            setUpdateDataTime(new Date().getTime()) 

            LoadNextOriginalImage(IndexOfContent, ImgIndex)
        }
    }

    // Preload下一張原圖
    function LoadNextOriginalImage(IndexOfContent, ImgIndex)
    {
        console.log(COMP_NAME + ".LoadNextOriginalImage: ", IndexOfContent, ImgIndex)

        if (
            (marrContentData[IndexOfContent].ImageList.length > 0) &&
            (ImgIndex < (marrContentData[IndexOfContent].ImageList.length - 1))
            )
        {
            // ImageList 還沒讀完
            mintIndexOfContentImage4PreloadImage++
            LoadOriginalImage(mintIndexOfContent4PreloadImage, mintIndexOfContentImage4PreloadImage)
        }
        else if (IndexOfContent < (marrContentData.length - 1))
        {
            // 這SuperQuestion 還沒讀完
            mintIndexOfContent4PreloadImage++
            mintIndexOfContentImage4PreloadImage = 0

            if (marrContentData[mintIndexOfContent4PreloadImage].ImageList.length > 0)
            {
                LoadOriginalImage(mintIndexOfContent4PreloadImage, mintIndexOfContentImage4PreloadImage)
            }
            else
            {
                LoadNextOriginalImage(mintIndexOfContent4PreloadImage, mintIndexOfContentImage4PreloadImage)
            }
        }
        else
        {
            PreloadOriginalImageProcessEnd()
        }
    }
    // #endregion Preload Original Image

    // #region Preload Thumbnail Image for Image Size

    // Preload縮圖流程開始
    function PreloadThumbnailImageProcessBegin()
    {
        console.log(COMP_NAME + ".PreloadThumbnailImageProcessBegin: ")

        mintIndexOfContent4PreloadImage = 0
        mintIndexOfContentImage4PreloadImage = 0

        if (marrContentData[mintIndexOfContent4PreloadImage].ImageList.length > 0)
        {
            LoadThumbnailImage(mintIndexOfContent4PreloadImage, mintIndexOfContentImage4PreloadImage)
        }
        else
        {
            LoadNextThumbnailImage(mintIndexOfContent4PreloadImage, mintIndexOfContentImage4PreloadImage)
        }
    }

    // Preload縮圖流程結束
    function PreloadThumbnailImageProcessEnd()
    {
        console.log(COMP_NAME + ".PreloadThumbnailImageProcessEnd: ")

        // Step 2. Preload 所有縮圖後 取得其高寬比例後 設定style 讓縮圖可顯示合適的大小
        marrContentData.forEach((ContentData) => {
            // 將ContentText內 所有的原圖URL 改成 縮圖URL 並且 在每一張圖上設定style指定高寬
            ContentData.ContentText = window.Globals.ChangeAllImageToThumbnailImageAndSpecifyWithHeight(ContentData.ContentText, ContentData.ImageList)
            console.log("marrContentData PreloadThumbnailImageProcessEnd")
        })

        console.log("marrContentData: ", marrContentData)

        InitContentDataProcessEnd()
    }

    // Preload縮圖
    function LoadThumbnailImage(IndexOfContent, ImgIndex)
    {
        console.log(COMP_NAME + ".LoadThumbnailImage: ", IndexOfContent, ImgIndex)

        let objImage = new Image()
        objImage.onload = function ()
        {
            ThumbnailImageLoadedHandler(IndexOfContent, ImgIndex, this.width, this.height)
        };
        objImage.src = marrContentData[IndexOfContent].ImageList[ImgIndex].ThumbnailImageUrl // Preload 縮圖
    }

    // 縮圖讀取完成後要做的處理
    function ThumbnailImageLoadedHandler(IndexOfContent, ImgIndex, Width, Height)
    {
        console.log(COMP_NAME + ".ThumbnailImageLoadedHandler: ", IndexOfContent, ImgIndex, Width, Height)

        // 避免 ThumbnailImageLoadedHandler 觸發的時候 已經換到其他頁 導致讀不到資料跳錯
        if(
            (marrContentData.length > 0) &&
            (typeof(marrContentData[IndexOfContent]) !== "undefined") &&
            (marrContentData[IndexOfContent] !== null) &&
            (typeof(marrContentData[IndexOfContent].ImageList) !== "undefined") &&
            (marrContentData[IndexOfContent].ImageList !== null) &&
            (typeof(marrContentData[IndexOfContent].ImageList[ImgIndex]) !== "undefined") &&
            (marrContentData[IndexOfContent].ImageList[ImgIndex] !== null)
            )
        {
            marrContentData[IndexOfContent].ImageList[ImgIndex].Width = Width
            marrContentData[IndexOfContent].ImageList[ImgIndex].Height = Height

            let intDisplayWidth = IMAGE_DISPLAY_WIDTH

            marrContentData[IndexOfContent].ImageList[ImgIndex].DisplayWidth = intDisplayWidth
            marrContentData[IndexOfContent].ImageList[ImgIndex].DisplayHeight = parseInt(intDisplayWidth / (Width / Height))

            console.log("DisplayHeight: ", parseInt(marrContentData[IndexOfContent].ImageList[ImgIndex].DisplayHeight))

            LoadNextThumbnailImage(IndexOfContent, ImgIndex)
        }
    }

    // Preload下一張縮圖
    function LoadNextThumbnailImage(IndexOfContent, ImgIndex)
    {
        console.log(COMP_NAME + ".LoadNextThumbnailImage: ", IndexOfContent, ImgIndex)

        if (
            (marrContentData[IndexOfContent].ImageList.length > 0) &&
            (ImgIndex < (marrContentData[IndexOfContent].ImageList.length - 1))
            )
        {
            // ImageList 還沒讀完
            mintIndexOfContentImage4PreloadImage++
            LoadThumbnailImage(mintIndexOfContent4PreloadImage, mintIndexOfContentImage4PreloadImage)
        }
        else if (IndexOfContent < (marrContentData.length - 1))
        {
            // ContentData 還沒讀完
            mintIndexOfContent4PreloadImage++
            mintIndexOfContentImage4PreloadImage = 0

            if (marrContentData[mintIndexOfContent4PreloadImage].ImageList.length > 0)
            {
                LoadThumbnailImage(mintIndexOfContent4PreloadImage, mintIndexOfContentImage4PreloadImage)
            }
            else
            {
                LoadNextThumbnailImage(mintIndexOfContent4PreloadImage, mintIndexOfContentImage4PreloadImage)
            }
        }
        else
        {
            PreloadThumbnailImageProcessEnd()
        }
    }
    
    // #endregion Preload Thumbnail Image for Image Size
  
    // #region Scroll

    function ScrollToTop()
    {
        console.log(COMP_NAME + ".ScrollToTop: ")

        let objScrollArea = document.getElementById("divScrollArea");
        console.log("objScrollArea: ", objScrollArea)
        if (objScrollArea !== null)
        {
            GlobalLibs.ExecuteScrollTo(objScrollArea, 0, 0, 0) // 回到最Top
        }
        setScrollButtonType(ScrollButtonEnum.More)
    }

    function SetScrollToTopOrMoreButton()
    {
        console.log(COMP_NAME + ".SetScrollToTopOrMoreButton: ");

        let objScrollArea = document.getElementById("divScrollArea")
        console.log("objScrollArea: ", objScrollArea)

        if(objScrollArea !== null)
        {
            if (objScrollArea.scrollHeight === objScrollArea.clientHeight)
            {
                // 目前無Scroll的效果
                setShowScrollButton(false)
            }
            else
            {
                // 目前有Scroll的效果
                setShowScrollButton(true)
            }
        }
    }

    // #endregion Scroll

    function TabIndexChanged(TagIndex)
    {
        console.log(COMP_NAME + ".TabIndexChanged: ", TagIndex)

        LoadAudioForAudioDuration(mintStateCurrentPageIndex, TagIndex)
        SetMoreButtonForMessage()
    }

    function ResetTeacherCommentAudioDuration()
    {
        console.log(COMP_NAME + ".ResetTeacherCommentAudioDuration")

        // Reset TeacherCommentAudioDuration
        setTeacherCommentAudioDuration(0)
    }

    function ResetSutdentAnswerAudioDuration()
    {
        console.log(COMP_NAME + ".ResetSutdentAnswerAudioDuration")

        // Reset SutdentAnswerAudioDuration
        setStudentRecordedAudioDuration(0)
    }

    // 換 CurrentPage, TabIndex 時 要去取得新的音檔的Duration
    function LoadAudioForAudioDuration(CurrentPageIndex, TagIndex)
    {
        console.log(COMP_NAME + ".LoadAudioForAudioDuration: ", CurrentPageIndex, TagIndex)
        // Reload audio for audio duration
        if (TagIndex === TagIndexEnum.StudentAnswer)
        {
            console.log("TabIndexChanged.TagIndexEnum.StudentAnswer")

            console.log("TabIndexChanged mobjTestSheetContext: ", mobjTestSheetContext)
            if (
                (typeof (mobjTestSheetContext) !== 'undefined') &&
                (mobjTestSheetContext !== null) &&
                (typeof (mobjTestSheetContext.AnswerList) !== 'undefined') &&
                (mobjTestSheetContext.AnswerList.length !== 0) &&
                (typeof (mobjTestSheetContext.AnswerList[CurrentPageIndex]) !== 'undefined')
                )
            {
                // preload use audio in page
                let strAudioUrl = mobjTestSheetContext.AnswerList[CurrentPageIndex].RecordedAnsFN
                if (strAudioUrl !== null)
                {
                    console.log("StudentAnswer Reload StudentRecordedAudioDuration")
                    strAudioUrl = GetAudioUrl4Play(mobjTestSheetContext.AnswerList[CurrentPageIndex].RecordedAnsFN, mobjTestSheetContext.AnswerList[CurrentPageIndex].AnswerID, mobjTestSheetContext.AssignID, mobjTestSheetContext.Mode)

                    window.AudioLibs.PreloadAudio(strAudioUrl)
                }
                else
                {
                    ResetSutdentAnswerAudioDuration()
                }
            }
            else
            {
                ResetSutdentAnswerAudioDuration()
            }
        }
        else if (TagIndex === TagIndexEnum.TeacherComment)
        {
            if (
                (typeof (mobjTestSheetContext) !== 'undefined') &&
                (mobjTestSheetContext !== null) &&
                (typeof (mobjTestSheetContext.AnswerList) !== 'undefined') &&
                (mobjTestSheetContext.AnswerList.length !== 0) &&
                (typeof (mobjTestSheetContext.AnswerList[CurrentPageIndex]) !== 'undefined')
                )
            {
                console.log("TeacherComment Reload TeacherCommentAudioDuration")
                let strAudioFN = mobjTestSheetContext.AnswerList[CurrentPageIndex].TeacherFeedbackAudioFN
                if (strAudioFN !== null)
                {
                    console.log("TabIndexChanged.TagIndexEnum.TeacherComment")
                    let strAssignID = mobjTestSheetContext.AssignID
                    console.log("strAssignID:", strAssignID)
                    let strTeacherFeedbackAudioFN = mobjTestSheetContext.AnswerList[CurrentPageIndex].TeacherFeedbackAudioFN
                    let strAudioUrl = window.Globals.GetUserNewAssignmentUrl(strAssignID, strTeacherFeedbackAudioFN);
                    console.log("strAudioUrl:", strAudioUrl)

                    window.AudioLibs.PreloadAudio(strAudioUrl)
                }
                else
                {
                    ResetTeacherCommentAudioDuration()
                }
            }
            else
            {
                ResetTeacherCommentAudioDuration()
            }
        }
    }

    /*===========================================
    summary: 註冊 執行 CompositionContent 動作
    remarks: 000 Tim 2021/12/29 Create
    ===========================================*/
    function RegisterExecuteCompositionContentAction()
    {
        let objCallbackData = {
            "Action": "RegisterExecuteCompositionContentAction",
            "Function": ExecuteCompositionContentAction
        }

        props.CallbackRef(objCallbackData)
    } // end of RegisterExecuteCompositionContentAction

    /*===========================================
    summary: 註冊 語言改變事件
    remarks: 000 Tim 2022/01/14 Create
    ===========================================*/
    function RegisterLanguageChangeHandler()
    {
        // console.log(COMP_NAME + ".RegisterLanguageChangeHandler: ")     // Richard 習慣這樣找 Function  Tim22.01.03
        console.log(COMP_NAME + ".RegisterLanguageChangeHandler BEGIN")
        
        let objCallbackData = {
            "Action": "RegisterLanguageChangeHandler",
            "Function": LanguageOnChangeHandler
        }
        props.CallbackRef(objCallbackData)
    } // end of RegisterLanguageChangeHandler

    /*===========================================
    summary: 執行 CompositionContent 動作
    remarks: 000 Tim 2021/12/29 Create
    ===========================================*/
    function ExecuteCompositionContentAction(Action)
    {
        console.log(COMP_NAME + ".ExecuteCompositionContentAction Action: ", Action)

        switch (Action)
        {
            case ExecuteActionEnum.Retry:
                setCurrentPageIndex(RETRY_PAGE_INDEX)
                setTagIndex(TagIndexEnum.StudentAnswer) // 切到Student's Answer
                break
            case ExecuteActionEnum.SaveAnswer:
                mintChangeAnimationType = window.gChangeAnimationTypeEnum.None // 如果點擊Save時 則Card不用動畫
                ExecuteSaveAnswer()
                break
            case ExecuteActionEnum.SubmitAnswer:
                if(!AllQuestionHaveAnswer())
                {
                    console.log("ExecuteCompositionContentAction.AllQuestionHaveAnswer")
                    let objAlertObject = {
                        Header: "",
                        Body: window.gAppUI.MSG_AssignmentSubmitCheckNotAllQuestionsHaveAnswer,
                        ShowCloseButton: false,
                        CallbackRef: SubmitNotAllQuestionsHaveAnswerAlertCallBack,
                        Buttons: [
                            {
                                Text: window.gAppUI.BTN_Cancel,
                                AutoFocus: false
                            },
                            {
                                Text: PackageVariablesLibs.UISettings.BTN_OK,
                                AutoFocus: true
                            }
                        ]
                    }
                    ShowAlert(objAlertObject)
                }
                else
                {
                    
                    
                    let objAlertObject = {
                        Header: "",
                        Body: window.gAppUI.MSG_AssignmentSubmitConfirm,
                        ShowCloseButton: false,
                        CallbackRef: SubmitConfirmAlertCallBack,
                        Buttons: [
                            {
                                Text: window.gAppUI.BTN_Cancel,
                                AutoFocus: false
                            },
                            {
                                Text: PackageVariablesLibs.UISettings.BTN_OK,
                                AutoFocus: true
                            }
                        ]
                    }
                    ShowAlert(objAlertObject)
                }
                break
            case ExecuteActionEnum.RegisterAudioEvent:
                console.log("ExecuteCompositionContentAction.RegisterAudioEvent: ")
                RegisterAudioEvent()
                break
            default:
                break
        } // end of switch (Action)
    } // end of ExecuteCompositionContentAction

    function AllQuestionHaveAnswer()
    {
        console.log(COMP_NAME + ".AllQuestionHaveAnswer: ")
        
        console.log("mobjTestSheetContext: ", mobjTestSheetContext)

        let blnAllQuestionHasAnswer = true
        if(
            (typeof (mobjTestSheetContext) !== 'undefined') &&
            (mobjTestSheetContext !== null) &&
            (typeof (mobjTestSheetContext.AnswerList) !== 'undefined') &&
            (mobjTestSheetContext.AnswerList.length > 0)
        )
        {
            // 目前有多個分頁可作答

            let i = 0
            while(
                blnAllQuestionHasAnswer &&
                (i < mobjTestSheetContext.AnswerList.length)
                )
            {
                console.log("i: ", i)
                // 存在分頁是沒有作答 - CompositionAns is null  RecordedAnsFN is null
                if(
                    (
                        (mobjTestSheetContext.AnswerList[i].CompositionAns === null) ||
                        (mobjTestSheetContext.AnswerList[i].CompositionAns === "")
                    )  // 沒寫文字
                    &&
                    (
                        (mobjTestSheetContext.AnswerList[i].RecordedAnsFN === null) ||
                        (mobjTestSheetContext.AnswerList[i].RecordedAnsFN === "")
                    ) // 沒錄音
                    &&
                    (mobjTestSheetContext.AnswerList[i].ImageAns01FN === null) // 上團圖片第1張沒圖
                    &&
                    (mobjTestSheetContext.AnswerList[i].ImageAns02FN === null) // 上團圖片第2張沒圖
                    &&
                    (mobjTestSheetContext.AnswerList[i].ImageAns03FN === null) // 上團圖片第3張沒圖
                )
                {
                    blnAllQuestionHasAnswer = false
                }
                i++
            }
        }

        return blnAllQuestionHasAnswer
    }

    /*===========================================
    summary: 改變 TestSheetMode
    remarks: 000 Tim 2021/12/30 Create
    ===========================================*/
    function ChangeTestSheetMode(TestSheetMode)
    {
        console.log(COMP_NAME + ".ChangeTestSheetMode: TestSheetMode: ", TestSheetMode)

        // 通知 上一層 
        let objCallbackData = {
            "Action": "ChangeTestSheetMode",
            "TestSheetMode": TestSheetMode
        }
        props.CallbackRef(objCallbackData)

        GoToPageAfterSetTestSheet()
    } // end of ChangeTestSheetMode

    function GoToPageAfterSetTestSheet()
    {
        console.log(COMP_NAME + ".GoToPageAfterSetTestSheet")
        let intPageNeedToGoToAfterSetTestSheet = mintStateCurrentPageIndex // 初始用原本的頁碼 e.g. 點擊Save, Submit時 才不會換到其他頁
        console.log("mintGoToLUSinceAction: ", mintGoToLUSinceAction)
        if (mintGoToLUSinceAction !== -1)
        {
            if (mintGoToLUSinceAction === GoToLUSinceActionEnum.GoPrev)
            {
                intPageNeedToGoToAfterSetTestSheet = mintTotalPages - 1
            }

            // 第一次進入LU時 判斷是用點擊/上一頁/下一頁進來的 而給予不同的<Card />動畫
            switch (mintGoToLUSinceAction)
            {
                case GoToLUSinceActionEnum.Default:
                    mintChangeAnimationType = window.gChangeAnimationTypeEnum.None
                    break;
                case GoToLUSinceActionEnum.GoPrev:
                    mintChangeAnimationType = window.gChangeAnimationTypeEnum.Prev
                    break;
                case GoToLUSinceActionEnum.GoNext:
                    mintChangeAnimationType = window.gChangeAnimationTypeEnum.Next
                    break;
                default:
                    break;
            }

            // 之後就沒有用了
            mintGoToLUSinceAction = -1
        }
        console.log("intPageNeedToGoToAfterSetTestSheet: ", intPageNeedToGoToAfterSetTestSheet)
        setCurrentPageIndex(intPageNeedToGoToAfterSetTestSheet)
        let objCallbackData = {
            "Action": "UpdateCanBeNavigatedInMultiPagedLU",
            "CanBePrev": (intPageNeedToGoToAfterSetTestSheet > 0),
            "CanBeNext": (intPageNeedToGoToAfterSetTestSheet < mintTotalPages - 1)
        }
        props.CallbackRef(objCallbackData)
    }

    function GetImageUrl4Display(ImageAnsFN, AnswerID, AssignID, TestSheetMode)
    {
        console.log(COMP_NAME + ".GetImageUrl4Display: ", ImageAnsFN, AnswerID, AssignID, TestSheetMode)

        let strImageUrl = ""
        if ((ImageAnsFN !== null) && (ImageAnsFN !== ""))
        {
            if (ImageAnsFN.indexOf("base64") !== -1)
            {
                // base64
                strImageUrl = ImageAnsFN
            }
            else
            {
                if (TestSheetMode === TestSheetModeEnum.Temp)
                {
                    strImageUrl = window.Globals.GetUserNewAssignmentTmpUrl(mstrBookCatID, props.LessonID, mstrLUCatSeqNo, window.gSession.Acc.ID, ImageAnsFN, AnswerID)
                }
                else if (TestSheetMode === TestSheetModeEnum.History)
                {
                    strImageUrl = window.Globals.GetUserNewAssignmentUrl(AssignID, ImageAnsFN)
                }
            }
        }

        return strImageUrl
    }

    function GetAudioUrl4Play(RecordedAnsFN, AnswerID, AssignID, TestSheetMode)
    {
        console.log(COMP_NAME + ".GetAudioUrl4Play: ", RecordedAnsFN, AnswerID, AssignID, TestSheetMode)

        let strAudioUrl = ""
        if ((RecordedAnsFN !== null) && (RecordedAnsFN !== ""))
        {
            if (RecordedAnsFN.indexOf("base64") !== -1)
            {
                // base64
                strAudioUrl = RecordedAnsFN
            }
            else
            {
                if (TestSheetMode === TestSheetModeEnum.Temp)
                {
                    strAudioUrl = window.Globals.GetUserNewAssignmentTmpUrl(mstrBookCatID, props.LessonID, mstrLUCatSeqNo, window.gSession.Acc.ID, RecordedAnsFN, AnswerID)
                }
                else if (TestSheetMode === TestSheetModeEnum.History)
                {
                    strAudioUrl = window.Globals.GetUserNewAssignmentUrl(AssignID, RecordedAnsFN)
                }
            }
        }

        return strAudioUrl

    }

    function IsTestSheetPageCouldBeCleared(PageIndex)
    {
        console.log(COMP_NAME + ".IsTestSheetPageCouldBeCleared: ", PageIndex)

        let blnHasAnswer = false
        if (mobjTestSheetContext.Mode !== TestSheetModeEnum.History)
        {
            let objAnswer = mobjTestSheetContext.AnswerList[PageIndex]
            if (
                (typeof (objAnswer) !== "undefined") &&
                (
                    (objAnswer.CompositionAns !== null) ||
                    (objAnswer.RecordedAnsFN !== null) ||
                    (objAnswer.ImageAns01FN !== null) ||
                    (objAnswer.ImageAns02FN !== null) ||
                    (objAnswer.ImageAns03FN !== null)
                    )
            )
            {
                blnHasAnswer = true
            }
        }

        return blnHasAnswer
    }

    function PageChanged(StateCurrentPageIndex)
    {
        console.log(COMP_NAME + ".PageChanged: ", StateCurrentPageIndex)

        if (StateCurrentPageIndex === RETRY_PAGE_INDEX)
        {
            mintStateCurrentPageIndex = 0
            // SetTestSheetObject(TestSheetModeEnum.New)
            GoToPageAfterSetTestSheet()
            return
        }
        else if (
            (StateCurrentPageIndex === INIT_PAGE_INDEX) // ||
            // (StateCurrentPageIndex === SAVE_PAGE_INDEX) || // 2023-08-23 Jeff 修改成 存檔時 不修改CurrentPageIndex 避免不必要的空白頁面
            // (StateCurrentPageIndex === SUBMIT_PAGE_INDEX) // 2023-08-23 Jeff 修改成 存檔時 不修改CurrentPageIndex 避免不必要的空白頁面
            )
        {
            return
        }

        // 正常換頁
        mintStateCurrentPageIndex = StateCurrentPageIndex

        console.log("mintStateCurrentPageIndex: ", mintStateCurrentPageIndex)

        console.log("mobjTestSheetContext: ", mobjTestSheetContext)

        console.log("mobjTestSheetContext.AnswerList[mintStateCurrentPageIndex]: ", mobjTestSheetContext.AnswerList[mintStateCurrentPageIndex])
        // richard: 這裡比較麻煩，換頁的時候，因為 Textarea 一定要用 state 的方式，
        // 所以要在這裡更新
        if (
            (typeof (mobjTestSheetContext) !== 'undefined') &&
            (mobjTestSheetContext !== null) &&
            (typeof (mobjTestSheetContext.AnswerList) !== 'undefined') &&
            (mobjTestSheetContext.AnswerList !== []) &&
            (typeof (mobjTestSheetContext.AnswerList[mintStateCurrentPageIndex]) !== 'undefined')
            )
        {
            let strAnsText = mobjTestSheetContext.AnswerList[mintStateCurrentPageIndex].CompositionAns
            if (strAnsText === null)
            {
                strAnsText = ""
            }
            setAnswerText(strAnsText)

            // preload use audio in page
            let strAudioUrl = mobjTestSheetContext.AnswerList[mintStateCurrentPageIndex].RecordedAnsFN
            if (strAudioUrl !== null)
            {
                strAudioUrl = GetAudioUrl4Play(mobjTestSheetContext.AnswerList[mintStateCurrentPageIndex].RecordedAnsFN, mobjTestSheetContext.AnswerList[mintStateCurrentPageIndex].AnswerID, mobjTestSheetContext.AssignID, mobjTestSheetContext.Mode)

                window.AudioLibs.PreloadAudio(strAudioUrl)
            }
        }

        // 換頁 應該要將 訊息More 還原  Tim22.01.25
        setStudentMessageHeight(-1)
        setTeacherMessageHeight(-1)

        LoadAudioForAudioDuration(mintStateCurrentPageIndex, mintStateTagIndex)
        SetMoreButtonForMessage()
        SetScrollToTopOrMoreButton()
    }

    function SetMoreButtonForMessage()
    {
        console.log(COMP_NAME + ".SetMoreButtonForMessage")

        if (mintStateTagIndex === TagIndexEnum.StudentAnswer)
        {
            console.log("SetMoreButtonForMessage.mrefStudentAnswerMessageArea.current:", mrefStudentAnswerMessageArea.current)
            console.log("SetMoreButtonForMessage.mrefStudentAnswerMessageText.current:", mrefStudentAnswerMessageText.current)
            if (
                (typeof (mrefStudentAnswerMessageArea.current) !== 'undefined') &&
                (mrefStudentAnswerMessageArea.current !== null) &&
                (typeof (mrefStudentAnswerMessageArea.current.clientHeight) !== 'undefined') &&
                (mrefStudentAnswerMessageArea.current.clientHeight !== null) &&
                (mrefStudentAnswerMessageArea.current.clientHeight > 0) &&
                (typeof (mrefStudentAnswerMessageText.current) !== 'undefined') &&
                (mrefStudentAnswerMessageText.current !== null) &&
                (typeof (mrefStudentAnswerMessageText.current.clientHeight) !== 'undefined') &&
                (mrefStudentAnswerMessageText.current.clientHeight !== null) &&
                (mrefStudentAnswerMessageText.current.clientHeight > 0)
                )
            {
                console.log("mrefStudentAnswerMessageArea.current.clientHeight:", mrefStudentAnswerMessageArea.current.clientHeight)
                console.log("mrefStudentAnswerMessageText.current.clientHeight:", mrefStudentAnswerMessageText.current.clientHeight)
                if (mrefStudentAnswerMessageArea.current.clientHeight < mrefStudentAnswerMessageText.current.clientHeight)
                {
                    setStudentShowMoreButton(true)
                }
                else
                {
                    setStudentShowMoreButton(false)
                }
            }
            else
            {
                setStudentShowMoreButton(false)
            }
        }
        else if (mintStateTagIndex === TagIndexEnum.TeacherComment)
        {
            console.log("SetMoreButtonForMessage.mrefTeacherCommentMessageArea.current:", mrefTeacherCommentMessageArea.current)
            console.log("SetMoreButtonForMessage.mrefTeacherCommentMessageText.current:", mrefTeacherCommentMessageText.current)
            if (
                (typeof (mrefTeacherCommentMessageArea.current) !== 'undefined') &&
                (mrefTeacherCommentMessageArea.current !== null) &&
                (typeof (mrefTeacherCommentMessageArea.current.clientHeight) !== 'undefined') &&
                (mrefTeacherCommentMessageArea.current.clientHeight !== null) &&
                (mrefTeacherCommentMessageArea.current.clientHeight > 0) &&
                (typeof (mrefTeacherCommentMessageText.current) !== 'undefined') &&
                (mrefTeacherCommentMessageText.current !== null) &&
                (typeof (mrefTeacherCommentMessageText.current.clientHeight) !== 'undefined') &&
                (mrefTeacherCommentMessageText.current.clientHeight !== null) &&
                (mrefTeacherCommentMessageText.current.clientHeight > 0)
                )
            {
                console.log("mrefTeacherCommentMessageArea.current.clientHeight:", mrefTeacherCommentMessageArea.current.clientHeight)
                console.log("mrefTeacherCommentMessageText.current.clientHeight:", mrefTeacherCommentMessageText.current.clientHeight)
                if (mrefTeacherCommentMessageArea.current.clientHeight < mrefTeacherCommentMessageText.current.clientHeight)
                {
                    setTeacherShowMoreButton(true)
                }
                else
                {
                    setTeacherShowMoreButton(false)
                }
            }
            else
            {
                setTeacherShowMoreButton(false)
            }
        }
    }

    function ExecuteSubmitAnswer()
    {
        console.log(COMP_NAME + ".ExecuteSubmitAnswer: mobjTestSheetContext: ", mobjTestSheetContext)

        marrAnswerList4Submit = mobjTestSheetContext.AnswerList
        // setCurrentPageIndex(SUBMIT_PAGE_INDEX) // 2023-08-23 Jeff 修改成 存檔時 不修改CurrentPageIndex 避免不必要的空白頁面
        // Submit 應該要將 訊息More 還原  Tim22.01.25
        setStudentMessageHeight(-1)
        setTeacherMessageHeight(-1)
        UploadNewAssignmentResult()
    }

    function UpdateCacheSinceSubmit(DataFromSubmit)
    {
        console.log(COMP_NAME + ".UpdateCacheSinceSubmit: ", DataFromSubmit)

        let objTestTime = new Date()
        // let arrAnswerList = []
        // marrAnswerList4Submit.forEach(Answer => {
        //     let objCachedAnswer = {
        //         TRAnswer: Answer.TRAnswer,
        //         TRAudioFN: Answer.TRAudioFN4CacheUpdate,
        //         TRScore: Answer.TRScore
        //     }

        //     arrAnswerList.push(objCachedAnswer)
        // })
        // let objNewAssign = {
        //     AnswerList: arrAnswerList,
        //     AssignID: DataFromSubmit.AssignID,
        //     Score: DataFromSubmit.Score,
        //     TestedTime: objTestTime.ToBCUTCString()
        // }
        let objNewAssign = {
            // Cached: true,
            // AnswerList: marrAnswerList4Submit,
            AnswerList: DataFromSubmit.AnswerList,
            AssignID: DataFromSubmit.AssignID,
            Score: DataFromSubmit.Score,
            TestedTime: objTestTime.ToBCUTCString()
        }

        // 更新 History 資料
        console.log("objNewAssign: ", objNewAssign)
        mobjLUCacheContext.AssigementHistoryList[mstrLUKey4LUCachedContext].NewAssignList.unshift(objNewAssign)

        // 清除 Temp 資料
        mobjLUCacheContext.AssignmentTempAnsList[mstrLUKey4LUCachedContext].AnswerList = []
        mobjLUCacheContext.AssignmentTempAnsList[mstrLUKey4LUCachedContext].TestedTime = null

        setUpdateDataTime(new Date().getTime())
    }

    function ExecuteSaveAnswer()
    {
        console.log(COMP_NAME + ".ExecuteSaveAnswer: mobjTestSheetContext: ", mobjTestSheetContext)
        if (mobjTestSheetContext.Dirty)
        {
            marrAnswerList4Save = mobjTestSheetContext.AnswerList
            // setCurrentPageIndex(SAVE_PAGE_INDEX) // 2023-08-23 Jeff 修改成 存檔時 不修改CurrentPageIndex 避免不必要的空白頁面
            UploadNewAssignmentTmpResult()
        }
    }

    function UpdateCacheSinceSaveTemp(DataFromSaveTemp)
    {
        console.log(COMP_NAME + ".UpdateCacheSinceSaveTemp: ", DataFromSaveTemp)

        mobjLUCacheContext.AssignmentTempAnsList[mstrLUKey4LUCachedContext] = DataFromSaveTemp
    }

    function UserImageUploadedGotton(ImageBase64)
    {
        console.log(COMP_NAME + ".UserImageUploadedGotton: ", ImageBase64)

        // mintImagePickerClickedIndex
        if (ImageBase64 !== "")
        {
            let strImageAnsFNKey = "ImageAns0" + (mintImagePickerClickedIndex + 1).toString() + "FN"

            console.log("mobjTestSheetContext: ", JSON.parse(JSON.stringify(mobjTestSheetContext)))

            mobjTestSheetContext.Dirty = true

            mobjTestSheetContext.AnswerList[mintStateCurrentPageIndex][strImageAnsFNKey] = ImageBase64

            console.log("mobjTestSheetContext: ", mobjTestSheetContext)

            let objCallbackData = {
                "Action": "TestSheetContextDirty"
            }
            props.CallbackRef(objCallbackData)
        }

        CloseLoadingMask()
    }

    function UserReordedGotton(AudioBase64)
    {
        console.log(COMP_NAME + ".UserReordedGotton: ", AudioBase64)

        if (AudioBase64 !== "")
        {
            console.log("mobjTestSheetContext: ", JSON.parse(JSON.stringify(mobjTestSheetContext)))

            mobjTestSheetContext.Dirty = true

            mobjTestSheetContext.AnswerList[mintStateCurrentPageIndex].RecordedAnsFN = AudioBase64

            console.log("mobjTestSheetContext: ", mobjTestSheetContext)

            let objCallbackData = {
                "Action": "TestSheetContextDirty"
            }
            props.CallbackRef(objCallbackData)

            window.AudioLibs.PreloadAudio(AudioBase64)

            // window.AudioLibs.PlayAudio(AudioBase64) // TEST
        }
        CloseLoadingMask()
    }

    function GetTextAudioPlayingTimeAndDuration(RecordedAudioDuration, RecordedAudioCurrentTime)
    {
        console.log(COMP_NAME + ".GetTextAudioPlayingTimeAndDuration: ")

        let strAudioTime = ""
        if (RecordedAudioDuration !== 0)
        {
            let intMinuteAudioDuration = Math.floor(RecordedAudioDuration / 60);
            let intSecondAudioDuration = Math.floor(RecordedAudioDuration % 60);
            let strSecondAudioDuration = intSecondAudioDuration.toString().PadLeft(2)
            let strAudioDuration = intMinuteAudioDuration + ":" + strSecondAudioDuration

            let intMinuteAudioCurrentTime = Math.floor(RecordedAudioCurrentTime / 60);
            let intSecondAudioCurrentTime = Math.floor(RecordedAudioCurrentTime % 60);
            let strSecondAudioCurrentTime = intSecondAudioCurrentTime.toString().PadLeft(2)
            let strAudioCurrentTime = intMinuteAudioCurrentTime.toString() + ":" + strSecondAudioCurrentTime

            strAudioTime = strAudioCurrentTime + " / " + strAudioDuration
        }

        return strAudioTime
    }

    function ResetStudentAnswerAndTeacherCommentAudioStatus()
    {
        console.log(COMP_NAME + ".ResetStudentAnswerAndTeacherCommentAudioStatus", )

        setStudentRecordedAudioPlayingStatus(PlayingStatusEnum.Stop)
        setStudentRecordedAudioDuration(0)
        setStudentRecordedAudioCurrentTime(0)
        setTeacherCommentAudioPlayStatus(PlayingStatusEnum.Stop)
        setTeacherCommentAudioDuration(0)
        setTeacherCommentAudioCurrentTime(0)
    }

    function SubmitNotAllQuestionsHaveAnswerAlertCallBack (BtnObject)
    {
        console.log(COMP_NAME + ".SubmitNotAllQuestionsHaveAnswerAlertCallBack.BtnObject: ", BtnObject);

        if (BtnObject.index === 1) // BTN_OK
        {
            console.log("SubmitNotAllQuestionsHaveAnswerAlertCallBack.OK")
            ExecuteSubmitAnswer()
        }
    }

    function SubmitConfirmAlertCallBack(BtnObject)
    {
        console.log(COMP_NAME + ".SubmitNotAllQuestionsHaveAnswerAlertCallBack.BtnObject: ", BtnObject);

        if (BtnObject.index === 1) // BTN_OK
        {
            console.log("SubmitConfirmAlertCallBack.OK")
            ExecuteSubmitAnswer()
        }
    }

    // #endregion Other Functions

    // #region Get ClassName and Style
    function GetPageIconCls(Index, CurrentIndex)
    {
        console.log(COMP_NAME + ".GetPageIconCls", Index, CurrentIndex);

        let objCls = cssCompositionContent.divPageIconUnSelect

        if (Index === CurrentIndex)
        {
            console.log("GetPageIconCls: divPageIconSelected")
            objCls = cssCompositionContent.divPageIconSelected
        }

        return objCls
    }

    function GetClsClearAnswerButton()
    {
        console.log(COMP_NAME + ".GetClsClearAnswerButton")
        let objCls = null

        if (mobjTestSheetContext.Mode === TestSheetModeEnum.History)
        {
            objCls = cssCompositionContent.btnClearAnswerDisable
        }
        else if (
            (mobjTestSheetContext.Mode === TestSheetModeEnum.Temp) ||
            mobjTestSheetContext.Dirty
        )
        {
            if (IsTestSheetPageCouldBeCleared(currentPageIndex))
            {
                if(props.PracticeEnable)
                {
                    objCls = cssCompositionContent.btnClearAnswer
                }
                else
                {
                    objCls = cssCompositionContent.btnClearAnswerDisable
                }
            }
            else
            {
                objCls = cssCompositionContent.btnClearAnswerDisable
            }
        }
        else if (mobjTestSheetContext.Mode === TestSheetModeEnum.New)
        {
            objCls = cssCompositionContent.divHidden
        }

        return objCls
    }

    function GetClsTag(TagIndex, StateCurrentTagIndex)
    {
        console.log(COMP_NAME + ".GetClsTag: ", TagIndex, StateCurrentTagIndex)
        let objCls = null
        if (
            (mobjTestSheetContext.Mode === TestSheetModeEnum.New) ||
            (mobjTestSheetContext.Mode === TestSheetModeEnum.Temp)
            )
        {
            objCls = cssCompositionContent.divTagTeacherCommentDisable
        }
        else if (mobjTestSheetContext.Mode === TestSheetModeEnum.History)
        {
            if (TagIndex === StateCurrentTagIndex)
            {
                objCls = cssCompositionContent.divTagTeacherCommentSelected
            }
            else
            {
                objCls = cssCompositionContent.divTagTeacherComment
            }
        }

        return objCls
    }

    function GetClsStudentAnswerTag(TagIndex, StateCurrentTagIndex)
    {
        console.log(COMP_NAME + ".GetClsStudentAnswerTag: ", TagIndex, StateCurrentTagIndex)
        let objCls = null
        if (TagIndex === StateCurrentTagIndex)
        {
            objCls = cssCompositionContent.divTagStudentAnswerSelected
        }
        else
        {
            objCls = cssCompositionContent.divTagStudentAnswer
        }
        return objCls
    }

    function GetStyleTextArea(StateSubTextHeight)
    {
        let objStyle = null

        // 某些 Web 裝置瀏覽器  mrefStudentAnswerMessageText.current.clientHeight 高度 偵測錯誤
        // 會缺少 84px，先硬加上去
        // 等 Jeff 之後再找真正原因     Tim22.01.25
        if (StateSubTextHeight > 0)
        {
            // 36px 為 上下留白空間
            objStyle = {
                // "height": (StateSubTextHeight + 36) + "px",
                "minHeight": (StateSubTextHeight + 36 + 84) + "px"
            }
        }

        return objStyle
    }

    function GetClsScrollTopOrMoreButton(StateScrollButtonType)
    {
        console.log(COMP_NAME + ".GetClsScrollButton: ", scrollButtonType);

        let objCls = null

        if (StateScrollButtonType === ScrollButtonEnum.Top)
        {
            objCls = cssCompositionContent.divScrollAreaScrollButtonTop
        }
        else if (StateScrollButtonType === ScrollButtonEnum.More)
        {
            objCls = cssCompositionContent.divScrollAreaScrollButtonMore
        }
        return objCls
    }
    // #endregion Get ClassName and Style

    // #region Web Service After Process
    function UploadNewAssignmentResultAfterProcess(ReturnData)
    {
        console.log(COMP_NAME + ".UploadNewAssignmentResultAfterProcess: ", ReturnData)

        UpdateCacheSinceSubmit(ReturnData)
        ChangeTestSheetMode(TestSheetModeEnum.History)
    }

    function UploadNewAssignmentTmpResultAfterProcess(ReturnData)
    {
        console.log(COMP_NAME + ".UploadNewAssignmentTmpResultAfterProcess: ", ReturnData)

        UpdateCacheSinceSaveTemp(ReturnData)
        ChangeTestSheetMode(TestSheetModeEnum.Temp)
    }
    // #endregion Web Service After Process

    // #region Web Service
    function UploadNewAssignmentResult()
    {
        console.log(COMP_NAME + ".UploadNewAssignmentResult: ")
        let objRetryFuncRef = UploadNewAssignmentResult
        if (!window.navigator.onLine)
        {
            GlobalLibs.OkErrorHandler(window.gAppUI.ERR_UploadAssignmentResult_Title, window.gAppUI.ERR_UploadAssignmentResult_Msg, objRetryFuncRef)
        }
        else
        {
            let objCallbackFuncRef = UploadNewAssignmentResultCallback

            // Open Loading mask with message
            OpenLoadingMask(window.gAppUI.MSG_LoadMask_UploadNewAssignmentResult)

            let objCallData = {
                "Func": "UploadNewAssignmentResult",
                "BookCategoryID": mstrBookCatID,
                "LessonID": props.LessonID,
                "ClassID": mintClassID,
                "LUCatSeqNo": props.LUInfo.LUCatSeqNo,
                "Answer": JSON.stringify(marrAnswerList4Submit)
            }

            NetworkLibs.WebServiceCall(objCallData, objRetryFuncRef)
                .then(Response => {
                    objCallbackFuncRef(Response)
                }
                )
        }
    }

    function UploadNewAssignmentResultCallback(Return)
    {
        console.log(COMP_NAME + ".UploadNewAssignmentResultCallback: ", Return)
        // Close Loading mask        
        CloseLoadingMask()

        // you need to customize these
        let intDefaultErrNo = window.gAppUI.ERR_UploadAssignmentTmpResult_No
        let strErrorTitle = window.gAppUI.ERR_UploadAssignmentResult_Title
        let strErrMsg = window.gAppUI.ERR_UploadAssignmentResult_Msg

        if (Return.ErrNo !== NetworkLibs.NetworkLibErrorEnum.WS_SYNC_CALL_ERR_NO_SUCCESS)
        {
            switch (Return.CalledErrNo)
            {
                // case customized error case:
                //     break
                default:
                    NetworkLibs.WSCallbackErrorHandler(Return.ErrNo, Return.CalledErrNo, Return.CalledErrMsg, intDefaultErrNo, strErrorTitle, strErrMsg)
                    break
            }

            console.log("UploadNewAssignmentResultCallback: ErrNo: ", Return.ErrNo)
            console.log("UploadNewAssignmentResultCallback: CalledErrNo: ", Return.CalledErrNo)
        }
        else
        {
            console.log("UploadNewAssignmentResultCallback Return.Data", Return.Data)

            UploadNewAssignmentResultAfterProcess(Return.Data)
        }
    }

    function UploadNewAssignmentTmpResult()
    {
        console.log(COMP_NAME + ".UploadNewAssignmentTmpResult: ")
        let objRetryFuncRef = UploadNewAssignmentTmpResult
        if (!window.navigator.onLine)
        {
            GlobalLibs.OkErrorHandler(window.gAppUI.ERR_UploadAssignmentTmpResult_Title, window.gAppUI.ERR_UploadAssignmentTmpResult_Msg, objRetryFuncRef)
        }
        else
        {
            let objCallbackFuncRef = UploadNewAssignmentTmpResultCallback

            // Open Loading mask with message
            OpenLoadingMask(window.gAppUI.MSG_LoadMask_UploadNewAssignmentTmpResult)

            let objCallData = {
                "Func": "UploadNewAssignmentTmpResult",
                "BookCategoryID": mstrBookCatID,
                "LessonID": props.LessonID,
                "ClassID": mintClassID,
                "LUCatSeqNo": props.LUInfo.LUCatSeqNo,
                "Answer": JSON.stringify(marrAnswerList4Save),
                "Score": null,
                "ActionType": 1 // 給TmpResult使用； ActionType  1: 存（實際上會清除再存） 2: 清空    
            }

            NetworkLibs.WebServiceCall(objCallData, objRetryFuncRef)
                .then(Response => {
                    objCallbackFuncRef(Response)
                }
                )
        }
    }

    function UploadNewAssignmentTmpResultCallback(Return)
    {
        console.log(COMP_NAME + ".UploadNewAssignmentTmpResultCallback: ", Return)
        // Close Loading mask        
        CloseLoadingMask()
        // setIsHistoryInited(true)

        // you need to customize these
        let intDefaultErrNo = window.gAppUI.ERR_UploadAssignmentTmpResult_No
        let strErrorTitle = window.gAppUI.ERR_UploadAssignmentTmpResult_Title
        let strErrMsg = window.gAppUI.ERR_UploadAssignmentTmpResult_Msg


        if (Return.ErrNo !== NetworkLibs.NetworkLibErrorEnum.WS_SYNC_CALL_ERR_NO_SUCCESS)
        {
            switch (Return.CalledErrNo)
            {
                // case customized error case:
                //     break
                default:
                    NetworkLibs.WSCallbackErrorHandler(Return.ErrNo, Return.CalledErrNo, Return.CalledErrMsg, intDefaultErrNo, strErrorTitle, strErrMsg)
                    break
            }

            console.log("UploadNewAssignmentTmpResultCallback: ErrNo: ", Return.ErrNo)
            console.log("UploadNewAssignmentTmpResultCallback: CalledErrNo: ", Return.CalledErrNo)
        }
        else
        {
            UploadNewAssignmentTmpResultAfterProcess(Return.Data)
        }
    }
    // #endregion Web Service

    // #region Component

    function ComponentStudentPlayButton({ ButtonEnabled, AudioUrl, StateStudentRecordedAudioPlayingStatus })
    {
        console.log(COMP_NAME + ".ComponentStudentPlayButton: ", ButtonEnabled, StateStudentRecordedAudioPlayingStatus)

        let objCls = ButtonEnabled ? cssCompositionContent.btnAudioPlay : cssCompositionContent.btnAudioPlayDisabled

        return (
            <div className={objCls} onClick={() => PlayStudentRecordedAudioOnTapHandler(AudioUrl, StateStudentRecordedAudioPlayingStatus)}></div>
        )
    }

    function ComponentStudentPauseButton({ ButtonEnabled })
    {
        console.log(COMP_NAME + ".ComponentStudentPauseButton: ", ButtonEnabled)

        let objCls = ButtonEnabled ? cssCompositionContent.btnAudioPause : cssCompositionContent.btnAudioPauseDisable

        return (
            <div className={objCls} onClick={() => PauseStudentRecordedAudioOnTapHandler()}></div>
        )
    }

    function ComponentStudentStopButton({ ButtonEnabled })
    {
        console.log(COMP_NAME + ".ComponentStudentStopButton: ", ButtonEnabled)

        let objCls = ButtonEnabled ? cssCompositionContent.btnAudioStop : cssCompositionContent.btnAudioStopDisabled

        return (
            <div className={objCls} onClick={() => StopStudentRecordedAudioOnTapHandler()}></div>
        )
    }

    function ComponentStudentDeleteButton({ ButtonEnabled, PracticeEnable })
    {
        console.log(COMP_NAME + ".ComponentStudentDeleteButton: ", ButtonEnabled, PracticeEnable)

        let objCls = (ButtonEnabled && PracticeEnable) ? cssCompositionContent.btnAudioDelete : cssCompositionContent.btnAudioDeleteDisabled

        return (
            <div className={objCls} onClick={() => DeleteAudioOnTapHandler()}></div>
        )
    }

    function ComponentTeacherPlayButton({ ButtonEnabled, AudioUrl, StateTeacherCommentAudioPlayStatus })
    {
        console.log(COMP_NAME + ".ComponentTeacherPlayButton: ", ButtonEnabled)

        let objCls = ButtonEnabled ? cssCompositionContent.btnAudioPlay : cssCompositionContent.btnAudioPlayDisabled

        return (
            <div className={objCls} onClick={() => PlayTeacherCommentAudioOnTapHandler(AudioUrl, StateTeacherCommentAudioPlayStatus)}></div>
        )
    }

    function ComponentTeacherPauseButton({ ButtonEnabled })
    {
        console.log(COMP_NAME + ".ComponentTeacherPauseButton: ", ButtonEnabled)

        let objCls = ButtonEnabled ? cssCompositionContent.btnAudioPause : cssCompositionContent.btnAudioPauseDisable

        return (
            <div className={objCls} onClick={() => PauseTeacherCommentAudioOnTapHandler()}></div>
        )
    }

    function ComponentTeacherPlayVideoButton({ ButtonEnabled, VideoUrl })
    {
        console.log(COMP_NAME + ".ComponentTeacherPlayVideoButton: ", ButtonEnabled)

        let objCls = ButtonEnabled ? cssCompositionContent.btnAudioPlay : cssCompositionContent.btnAudioPlayDisabled

        return (
            <div className={objCls} onClick={() => TeacherCommentVideoPlayOnTapHandler(VideoUrl)}></div>
        )
    }

    function ComponentTeacherStopButton({ ButtonEnabled })
    {
        console.log(COMP_NAME + ".ComponentTeacherStopButton: ", ButtonEnabled)

        let objCls = ButtonEnabled ? cssCompositionContent.btnAudioStop : cssCompositionContent.btnAudioStopDisabled

        return (
            <div className={objCls} onClick={() => StopTeacherCommentAudioOnTapHandler()}></div>
        )
    }

    // #endregion Component

    // #region Render
    function RenderPageSuperQuestionArea(StateCurrentPageIndex)
    {
        console.log(COMP_NAME + ".RenderPageSuperQuestionArea: ", StateCurrentPageIndex)

        let strContentText = ""
        if(
            (marrContentData.length > 0) &&
            (typeof(marrContentData[StateCurrentPageIndex]) !== "undefined") &&
            (marrContentData[StateCurrentPageIndex] !== null) &&
            (typeof(marrContentData[StateCurrentPageIndex].ContentText) !== "undefined") &&
            (marrContentData[StateCurrentPageIndex].ContentText !== null)
        )
        {
            strContentText = marrContentData[StateCurrentPageIndex].ContentText
        }
        console.log("strContentText: ", strContentText)

        let objBlock = null
        if(updateDataTime > 0)
        {
            objBlock = (
                <>
                    {parse(strContentText)}
                </>
            )
        }
        else
        {
            // Loading Icon
            objBlock = (
                <div className={cssCompositionContent.divCircularProgressArea}>
                    {/* Change color and position of CircularProgress? Ref: https://stackoverflow.com/questions/59709633/change-color-and-position-of-circularprogress */}
                    <CircularProgress />
                </div>
            )
        }
        return objBlock
    }

    function RenderStudentMoreButton(StateIsShowTextMore, StateSubTextHeight)
    {
        console.log(COMP_NAME + ".RenderStudentMoreButton: ", StateIsShowTextMore, StateSubTextHeight)
        if (
            (StateIsShowTextMore) &&
            (StateSubTextHeight < 0)
            )
        {
            return (
                <div className={cssCompositionContent.btnMore4TextAnswer} onClick={() => StudentMoreOnTapHandler()}>
                    {window.gAppUI.BTN_More}
                </div>
            )
        }
    }

    function RenderTeacherMoreButton(StateIsShowTextMore, StateSubTextHeight)
    {
        console.log(COMP_NAME + ".RenderTeacherMoreButton: ", StateIsShowTextMore, StateSubTextHeight)
        if (
            (StateIsShowTextMore) &&
            (StateSubTextHeight < 0)
            )
        {
            return (
                <div className={cssCompositionContent.btnMore4TextAnswer} onClick={() => TeacherMoreOnTapHandler()}>
                    {window.gAppUI.BTN_More}
                </div>
            )
        }
    }

    function RenderStudentAnswerMessageArea()
    {
        console.log(COMP_NAME + ".RenderStudentAnswerMessageArea: ")

        // RecordedAnsFN
        console.log("mobjTestSheetContext: ", mobjTestSheetContext)
        console.log("currentPageIndex: ", currentPageIndex)
        console.log("mobjTestSheetContext.AnswerList[currentPageIndex].CompositionAns: ", mobjTestSheetContext.AnswerList[currentPageIndex].CompositionAns)
        let strAnsText = mobjTestSheetContext.AnswerList[currentPageIndex].CompositionAns

        if (strAnsText === null)
        {
            strAnsText = ""
        }
        else 
        {
            strAnsText = strAnsText.replace(/\r\n|\r|\n/g,"<br />") // 將換行符號 轉成 <br />
        }
        console.log("strAnsText: ", strAnsText)

        let objBlockMessage = null
        if (
            (mobjTestSheetContext.Mode === TestSheetModeEnum.New) ||
            (mobjTestSheetContext.Mode === TestSheetModeEnum.Temp)
            )
        {
            if(props.PracticeEnable)
            {
                objBlockMessage = (
                    <div className={cssCompositionContent.divStudnentAnswerMessageArea}>
                        <div className={cssCompositionContent.divStudnetAnswerTextareaIcon}></div>
                        <label htmlFor="textareaMessage" className={cssCompositionContent.divHidden}>{window.gAppUI.LBL_Message}</label>
                        <textarea
                            // id="textareaMessage"
                            className={cssCompositionContent.textareaMessage}
                            value={answerText}
                            maxLength={MAX_MESSAGE_CHARACHERS}
                            placeholder={window.gAppUI.LBL_InputAnswerPlaceHolder}
                            onChange={(event) => AnswerTextOnChangeHandler(event)}
                        />
                    </div>
                )
            }
            else
            {
                let objStyle = GetStyleTextArea(studentMessageHeight)
                objBlockMessage = (
                    <div className={cssCompositionContent.divStudnentAnswerHistoryMessageArea} style={objStyle}>
                        <div className={cssCompositionContent.divStudnetAnswerTextareaIconDisable}></div>
                        <div ref={mrefStudentAnswerMessageArea} className={cssCompositionContent.divStudnentAnswerHistoryMessageTextArea}>
                            <div ref={mrefStudentAnswerMessageText} className={cssCompositionContent.divStudnentAnswerHistoryMessageText}>
                                {parse(strAnsText)}
                            </div>
                        </div>

                        {RenderStudentMoreButton(studentShowMoreButton, studentMessageHeight)}
                    </div>
                )
            }
        }
        else if (mobjTestSheetContext.Mode === TestSheetModeEnum.History)
        {
            let objStyle = GetStyleTextArea(studentMessageHeight)
            objBlockMessage = (
                <div className={cssCompositionContent.divStudnentAnswerHistoryMessageArea} style={objStyle}>
                    <div className={cssCompositionContent.divStudnetAnswerTextareaIconDisable}></div>
                    <div ref={mrefStudentAnswerMessageArea} className={cssCompositionContent.divStudnentAnswerHistoryMessageTextArea}>
                        <div ref={mrefStudentAnswerMessageText} className={cssCompositionContent.divStudnentAnswerHistoryMessageText}>
                            {parse(strAnsText)}
                        </div>
                    </div>

                    {RenderStudentMoreButton(studentShowMoreButton, studentMessageHeight)}
                </div>
            )
        }
        
        return objBlockMessage
    }

    function RenderAnswerAudioAreaAudioExisted(AudioUrl)
    {
        console.log(COMP_NAME + ".RenderAnswerAudioAreaAudioExisted: ", AudioUrl)

        let objBlockPlayPause = null
        if (studentRecordedAudioPlayingStatus === PlayingStatusEnum.Playing)
        {
            objBlockPlayPause = <ComponentStudentPauseButton ButtonEnabled={true} />
        }
        else if (
            (studentRecordedAudioPlayingStatus === PlayingStatusEnum.Paused) ||
            (studentRecordedAudioPlayingStatus === PlayingStatusEnum.Stop)
            )
        {
            objBlockPlayPause = <ComponentStudentPlayButton ButtonEnabled={true} AudioUrl={AudioUrl} StateStudentRecordedAudioPlayingStatus={studentRecordedAudioPlayingStatus} />
        }

        let objBlockDelete = null
        if (mobjTestSheetContext.Mode !== TestSheetModeEnum.History)
        {
            objBlockDelete = <ComponentStudentDeleteButton ButtonEnabled={studentRecordedAudioPlayingStatus === PlayingStatusEnum.Stop} PracticeEnable={props.PracticeEnable} />
        }

        let blnStopButtonEnable = (studentRecordedAudioPlayingStatus === PlayingStatusEnum.Playing) || (studentRecordedAudioPlayingStatus === PlayingStatusEnum.Paused)
        return (
            <>
                <div className={cssCompositionContent.divAuiodPlayStopDeleteArea}>
                    {objBlockPlayPause}
                    <ComponentStudentStopButton ButtonEnabled={blnStopButtonEnable} />
                    {objBlockDelete}
                </div>
                <div className={cssCompositionContent.divAudioPlayingTimeArea}>
                    {GetTextAudioPlayingTimeAndDuration(studentRecordedAudioDuration, studentRecordedAudioCurrentTime)}
                </div>
            </>
        )
    }

    function RenderAnswerAudioAreaAudioNotExisted()
    {
        console.log(COMP_NAME + ".RenderAnswerAudioAreaAudioNotExisted: ")
        return (
            <>
                <div className={cssCompositionContent.divTapToStartRecording}>{window.gAppUI.LBL_TapToStartRecording}</div>
                <div className={cssCompositionContent.divSRStart} onClick={() => ShowAudioRecordingWindowOnTapHandler()}></div>
            </>
        )
    }

    function RenderHistoryAnswerAudioAreaAudioNotExisted()
    {
        console.log(COMP_NAME + ".RenderHistoryAnswerAudioAreaAudioNotExisted: ")
        return (
            <>
                <div className={cssCompositionContent.divTapToStartRecordingDisable}>{window.gAppUI.LBL_TapToStartRecording}</div>
                <div className={cssCompositionContent.divSRStartDisable}></div>
            </>
        )
    }

    function RenderAnswerAudioArea()
    {
        console.log(COMP_NAME + ".RenderAnswerAudioArea: ")

        let strAudioUrl = mobjTestSheetContext.AnswerList[currentPageIndex].RecordedAnsFN
        let objArea = null

        if (strAudioUrl !== null)
        {
            strAudioUrl = GetAudioUrl4Play(mobjTestSheetContext.AnswerList[currentPageIndex].RecordedAnsFN, mobjTestSheetContext.AnswerList[currentPageIndex].AnswerID, mobjTestSheetContext.AssignID, mobjTestSheetContext.Mode)
            objArea = RenderAnswerAudioAreaAudioExisted(strAudioUrl)
        }
        else
        {
            if (
                (mobjTestSheetContext.Mode === TestSheetModeEnum.New) ||
                (mobjTestSheetContext.Mode === TestSheetModeEnum.Temp)
                )
            {
                if(props.PracticeEnable)
                {
                    objArea = RenderAnswerAudioAreaAudioNotExisted()
                }
                else
                {
                    objArea = RenderHistoryAnswerAudioAreaAudioNotExisted()
                }
            }
            else if (mobjTestSheetContext.Mode === TestSheetModeEnum.History)
            {
                objArea = RenderHistoryAnswerAudioAreaAudioNotExisted()
                // 提供無音檔播放的按鈕
                // objArea = (
                //     <div className={cssCompositionContent.divAuiodPlayStopDeleteArea}>
                //         <ComponentStudentPlayButton ButtonEnabled={false} />
                //     </div>
                // )
            }
        }

        return (
            <div className={cssCompositionContent.divStudentAnswerSRArea}>
                {objArea}
            </div>
        )
    }

    function RenderAnswerImageAreaNotExisted(Index)
    {
        console.log(COMP_NAME + ".RenderAnswerImageAreaNotExisted: ")

        let objBlockSelectFileInput = null
        if (
            (mobjTestSheetContext.Mode === TestSheetModeEnum.New) ||
            (mobjTestSheetContext.Mode === TestSheetModeEnum.Temp)
            )
        {
            objBlockSelectFileInput =
                <div className={cssCompositionContent.divUploadImageLabelArea}>
                    <input type="file"
                        className={cssCompositionContent.labUploadImage}
                        accept="image/jpg, image/jpeg, image/png, image/bmp"
                        onChange={e => FilePickerOnChangeHandler(e, Index)}>
                    </input>
                </div>
        }

        return (
            <>
                <div className={cssCompositionContent.divUploadImageDisplayArea}>
                    <div className={cssCompositionContent.divUploadImage} />
                    <div className={cssCompositionContent.divUploadText}>
                        {window.gAppUI.LBL_AddImage}
                    </div>
                </div>
                {objBlockSelectFileInput}
            </>
        )
    }

    function OpenImageEditor(ImageUrl, ImageInputIndex)
    {
        console.log(COMP_NAME + ".OpenImageEditor: ", ImageUrl)

        mintImagePickerClickedIndex = ImageInputIndex

        let objArguments = {
            "ImageBase64": ImageUrl
        }

        // setImageBase64(e.target.result)
        let objCallbackData = {
            "Action": "ImageEditorWindowOpen",
            "CallbackRef": ImageEditorWindowCallback,
            "Arguments": objArguments
        }
        console.log("objCallbackData:", objCallbackData)
        props.CallbackRef(objCallbackData)

    }

    function RenderAnswerImageAreaExisted(ImageUrl, ImageAnsFNKey, ImageInputIndex)
    {
        console.log(COMP_NAME + ".RenderAnswerImageAreaExisted: ", ImageUrl, ImageAnsFNKey, ImageInputIndex)

        let objStyle = null
        if (ImageUrl !== "")
        {
            objStyle = {
                backgroundImage: `url(${ImageUrl})`
            }
        }

        let objBlockDelteButton = null
        if (
            (mobjTestSheetContext.Mode === TestSheetModeEnum.New) ||
            (mobjTestSheetContext.Mode === TestSheetModeEnum.Temp)
            )
        {
            if(props.PracticeEnable)
            {
                objBlockDelteButton = RenderDeleteImageArea(ImageAnsFNKey)
            }
        }

        let objBlockUploadImage = null
        if (
            (mobjTestSheetContext.Mode === TestSheetModeEnum.New) ||
            (mobjTestSheetContext.Mode === TestSheetModeEnum.Temp)
            )
        {
            console.log("RenderAnswerImageAreaExisted.ImageUrl: ", ImageUrl)
            if(ImageUrl.indexOf("base64") !== -1)
            {
                console.log("RenderAnswerImageAreaExisted.base64")
                // 目前是Base64的格式 才可用Canvas編輯
                objBlockUploadImage = <div className={cssCompositionContent.divUploadImage} style={objStyle} onClick={() => OpenImageEditor(ImageUrl, ImageInputIndex)}></div>
            }
            else
            {
                console.log("RenderAnswerImageAreaExisted.Notbase64")
                // 非Base64的格式 只可檢視
                objBlockUploadImage = <div className={cssCompositionContent.divUploadImage} style={objStyle} onClick={() => HasUploadImageAreaOnTapHandler(ImageUrl, ImageAnsFNKey)}></div>
            }
            
        }
        else if (mobjTestSheetContext.Mode === TestSheetModeEnum.History)
        {
            // History 只可檢視
            objBlockUploadImage = <div className={cssCompositionContent.divUploadImage} style={objStyle} onClick={() => HasUploadImageAreaOnTapHandler(ImageUrl, ImageAnsFNKey)}></div>
        }

        return (
            <>
                {objBlockUploadImage}
                {objBlockDelteButton}
            </>
        )
    }

    function RenderDeleteImageArea(ImageAnsFNKey)
    {
        console.log(COMP_NAME + ".RenderDeleteImageArea: ", ImageAnsFNKey)

        return (
            <div className={cssCompositionContent.btnDelteImage} onClick={() => DeleteImageOnTapHandler(ImageAnsFNKey)}></div>
        )
    }

    function GetClsUploadImageArea(ImageUrl)
    {
        console.log(COMP_NAME + ".GetClsUploadImageArea: ")
        let objCls = null
        if (ImageUrl !== null)
        {
            // 有圖片時 可點擊
            objCls = cssCompositionContent.divUploadImageArea
        }
        else
        {
            if (
                (mobjTestSheetContext.Mode === TestSheetModeEnum.New) ||
                (mobjTestSheetContext.Mode === TestSheetModeEnum.Temp)
                )
            {
                if(props.PracticeEnable)
                {
                    // 無圖片時 且編輯模式 可點擊
                    objCls = cssCompositionContent.divUploadImageArea
                }
                else
                {
                    // 不允許Practice時 無圖片時 不可點擊
                    objCls = cssCompositionContent.divUploadImageAreaDisable
                }
            }
            else if (mobjTestSheetContext.Mode === TestSheetModeEnum.History)
            {
                // 無圖片時 且歷史模式 不可點擊
                objCls = cssCompositionContent.divUploadImageAreaDisable
            }
        }
        return objCls
    }

    function RenderAnswerUploadImageArea(Index)
    {
        console.log(COMP_NAME + ".RenderAnswerUploadImageArea: ", Index)

        console.log("mintStateCurrentPageIndex: ", mintStateCurrentPageIndex)
        console.log("currentPageIndex: ", currentPageIndex)
        let strImageAnsFNKey = "ImageAns0" + (Index + 1).toString() + "FN"
        let strImageUrl = mobjTestSheetContext.AnswerList[currentPageIndex][strImageAnsFNKey]
        console.log("strImageAnsFNKey: ", strImageAnsFNKey)
        console.log("strImageUrl: ", strImageUrl)

        // ImageAns0?FN 0?: 由 Index 決定
        let objArea = null
        if (strImageUrl !== null)
        {
            strImageUrl = GetImageUrl4Display(strImageUrl, mobjTestSheetContext.AnswerList[currentPageIndex].AnswerID, mobjTestSheetContext.AssignID, mobjTestSheetContext.Mode)
            objArea = RenderAnswerImageAreaExisted(strImageUrl, strImageAnsFNKey, Index)
        }
        else
        {
            objArea = RenderAnswerImageAreaNotExisted(Index)
        }

        return (
            <div className={GetClsUploadImageArea(strImageUrl)}>
                {objArea}
            </div>
        )
    }

    function RenderAnswerImageWrapperArea()
    {
        console.log(COMP_NAME + ".RenderAnswerImageWrapperArea: ")
        // 有三個 User Image
        return (
            <div className={cssCompositionContent.divStudnentAnswerUploadImageArea}>
                {RenderAnswerUploadImageArea(0)}
                {RenderAnswerUploadImageArea(1)}
                {RenderAnswerUploadImageArea(2)}
            </div>
        )
    }

    function RenderStudentAnswerArea()
    {
        console.log(COMP_NAME + ".RenderStudentAnswerArea: ")

        return (
            <div className={cssCompositionContent.divStudentAnswerScrollArea}>
                {RenderAnswerAudioArea()}
                <div className={cssCompositionContent.divHorizontalBar}></div>
                {RenderStudentAnswerMessageArea()}
                <div className={cssCompositionContent.divHorizontalBar}></div>
                {RenderAnswerImageWrapperArea()}
                <div className={cssCompositionContent.divStudnentAnswerClearAnswerArea}>
                    <div className={GetClsClearAnswerButton()} onClick={() => ClearAnswerOnTapHandler()}>
                        {window.gAppUI.BTN_ClearAnswer}
                    </div>
                </div>
            </div>
        )
    }

    function RenderTeacherCommentAudioArea()
    {
        console.log(COMP_NAME + ".RenderTeacherCommentAudioArea: ")

        let strAssignID = mobjTestSheetContext.AssignID
        console.log("strAssignID:", strAssignID)
        let strTeacherFeedbackAudioFN = mobjTestSheetContext.AnswerList[currentPageIndex].TeacherFeedbackAudioFN
        let strAudioUrl = window.Globals.GetUserNewAssignmentUrl(strAssignID, strTeacherFeedbackAudioFN);
        console.log("strAudioUrl:", strAudioUrl)

        let objBlockPlayPause = null
        if (teacherCommentAudioPlayStatus === PlayingStatusEnum.Playing)
        {
            objBlockPlayPause = <ComponentTeacherPauseButton ButtonEnabled={true} />
        }
        else if (
            (teacherCommentAudioPlayStatus === PlayingStatusEnum.Paused) ||
            (teacherCommentAudioPlayStatus === PlayingStatusEnum.Stop)
            )
        {
            let blnPlayButtonEnable = (mobjTestSheetContext.AnswerList[currentPageIndex].TeacherFeedbackAudioFN !== null) ? true : false
            objBlockPlayPause = <ComponentTeacherPlayButton ButtonEnabled={blnPlayButtonEnable} AudioUrl={strAudioUrl} StateTeacherCommentAudioPlayStatus={teacherCommentAudioPlayStatus} />
        }

        let blnStopButtonEnable = (teacherCommentAudioPlayStatus === PlayingStatusEnum.Playing) || (teacherCommentAudioPlayStatus === PlayingStatusEnum.Paused)

        return (
            <div className={cssCompositionContent.divTeacherCommentAudioArea}>
                <div className={cssCompositionContent.divTeacherCommentMicrophoneIcon}></div>
                <div className={cssCompositionContent.divTeacherCommentPlayStopArea}>
                    {objBlockPlayPause}
                    <ComponentTeacherStopButton ButtonEnabled={blnStopButtonEnable} />
                </div>
                <div className={cssCompositionContent.divTeacherCommentAudioTime}>{GetTextAudioPlayingTimeAndDuration(teacherCommentAudioDuration, teacherCommentAudioCurrentTime)}</div>
            </div>
        )
    }

    function RenderCommentVideoArea()
    {
        console.log(COMP_NAME + ".RenderCommentVideoArea: ")

        let strVideoUrl = ""
        if (mobjTestSheetContext.AnswerList[currentPageIndex].TeacherFeedbackVideoFN !== null)
        {
            let strTeacherFeedbackVideoFN = mobjTestSheetContext.AnswerList[currentPageIndex].TeacherFeedbackVideoFN
            console.log("strTeacherFeedbackVideoFN:", strTeacherFeedbackVideoFN)
            let strAssignID = mobjTestSheetContext.AssignID
            console.log("strAssignID:", strAssignID)
            strVideoUrl = window.Globals.GetUserNewAssignmentUrl(strAssignID, strTeacherFeedbackVideoFN);
            console.log("strVideoUrl:", strVideoUrl)
        }

        let blnPlayButtonEnable = (mobjTestSheetContext.AnswerList[currentPageIndex].TeacherFeedbackVideoFN !== null) ? true : false

        return (
            <div className={cssCompositionContent.divTeacherCommentVideoArea}>
                <div className={cssCompositionContent.divTeacherCommentVideoIcon}></div>
                <ComponentTeacherPlayVideoButton ButtonEnabled={blnPlayButtonEnable} VideoUrl={strVideoUrl} />
            </div>
        )
    }

    function RenderCommentTextArea()
    {
        console.log(COMP_NAME + ".RenderCommentTextArea: ")

        let strTeacherFeedbackText = mobjTestSheetContext.AnswerList[currentPageIndex].TeacherFeedbackText
        console.log("strTeacherFeedbackText:", strTeacherFeedbackText)

        return (
            <div className={cssCompositionContent.divTeacherCommentMessageArea} style={GetStyleTextArea(teacherMessageHeight)}>
                <div className={cssCompositionContent.divTeacherCommentTextareaIcon}></div>
                <div ref={mrefTeacherCommentMessageArea} className={cssCompositionContent.divTeacherCommentMessageTextArea}>
                    <div ref={mrefTeacherCommentMessageText} className={cssCompositionContent.divTeacherCommentMessageText}>
                        {strTeacherFeedbackText}
                    </div>
                </div>

                {RenderTeacherMoreButton(teacherShowMoreButton, teacherMessageHeight)}
            </div>
        )
    }

    function RenderTeacherCommentArea()
    {
        console.log(COMP_NAME + ".RenderTeacherCommentArea: ")
        return (
            <div className={cssCompositionContent.divTeacherCommentScrollArea}>
                {RenderTeacherCommentAudioArea()}
                <div className={cssCompositionContent.divHorizontalBar}></div>
                {RenderCommentVideoArea()}
                <div className={cssCompositionContent.divHorizontalBar}></div>
                {RenderCommentTextArea()}
            </div>
        )
    }

    function RenderPageTestSheetArea(PageAnswerInTestSheet)
    {
        console.log(COMP_NAME + ".RenderPageTestSheetArea: ", PageAnswerInTestSheet)

        let objBlock = null
        if (tagIndex === TagIndexEnum.StudentAnswer)
        {
            objBlock = RenderStudentAnswerArea()
        }
        else if (tagIndex === TagIndexEnum.TeacherComment)
        {
            objBlock = RenderTeacherCommentArea()
        }

        return (
            <>
                <div className={cssCompositionContent.divTagArea}>
                    <div className={GetClsStudentAnswerTag(TagIndexEnum.StudentAnswer, tagIndex)} onClick={() => TabOnTapHandler(TagIndexEnum.StudentAnswer)}>
                        {window.gAppUI.LBL_StudentsAnswer}
                    </div>
                    <div className={GetClsTag(TagIndexEnum.TeacherComment, tagIndex)} onClick={() => TabOnTapHandler(TagIndexEnum.TeacherComment)}>
                        {window.gAppUI.LBL_TeachersComments}
                    </div>
                </div>

                {objBlock}
                {/* TestSheetArea */}
            </>
        )
    }

    function RenderScrollTopOrMoreButton()
    {
        // console.log(COMP_NAME + ".RenderScrollTopOrMoreButton")
        let objBlock = null
        if(showScrollButton)
        {
            objBlock = (
                <div className={GetClsScrollTopOrMoreButton(scrollButtonType)} onClick={() => ScrollAreaScrollToTopOrMoreOnTapHandler()}></div>
            )
        }
        return objBlock
    }

    function RenderPageContent(StateCurrentPageIndex)
    {
        console.log(COMP_NAME + ".RenderPageContent: ", StateCurrentPageIndex)

        let objAnswer = mobjTestSheetContext.AnswerList[StateCurrentPageIndex]
        let objPageTestSheetArea = RenderPageTestSheetArea(objAnswer)

        return (
            <div className={cssCompositionContent.divPageContentArea}>
                <div className={cssCompositionContent.divSuperQuestionArea}>
                    <div id="divScrollArea" className={cssCompositionContent.divSuperQuestionContentArea} onScroll={(event) => ScrollAreaScrollEventHandler(event)}>
                        {RenderPageSuperQuestionArea(StateCurrentPageIndex)}
                    </div>
                    {RenderScrollTopOrMoreButton()}
                </div>
                <div className={cssCompositionContent.divContentSeparator}></div>
                <div className={cssCompositionContent.divPageTestSheetArea}>
                    {objPageTestSheetArea}
                </div>
            </div>
        )
    }

    function RenderPageNumberIconArea(StateCurrentPageIndex)
    {
        console.log(COMP_NAME + ".RenderPageNumberIconArea: ", StateCurrentPageIndex, mintTotalPages)
        let objBlock = null

        if (props.LUInfo.SuperQuestion.length > 1)
        {
            // 顯示頁碼
            objBlock = (
                <div className={cssCompositionContent.divPageNumberArea}>
                    <div className={cssCompositionContent.divPageIconContainer}>
                        {props.LUInfo.SuperQuestion.map((SuperQuestionItem, SuperQuestionIndex) =>
                            <div key={SuperQuestionIndex} className={cssCompositionContent.divPageIconBlock}>
                                <div className={GetPageIconCls(SuperQuestionIndex, StateCurrentPageIndex)}></div>
                            </div>
                        )}
                    </div>
                </div>
            )
        }
        return objBlock
    }

    /*===========================================
    summary: Render Content 的顯示  將原本Jeff寫的 RenderMainArea 搬過來
    remarks: 000 Tim 2022/01/07 Create
    ===========================================*/
    function RenderContentArea(StateCurrentPageIndex)
    {
        const FUNC_NAME = "RenderContentArea"
        console.log(COMP_NAME + "." + FUNC_NAME + ": ")
        console.log(COMP_NAME + "." + FUNC_NAME + " mobjTestSheetContext: ", mobjTestSheetContext)
        console.log(COMP_NAME + "." + FUNC_NAME + " StateCurrentPageIndex: ", StateCurrentPageIndex)

        if (
            (StateCurrentPageIndex === INIT_PAGE_INDEX) ||
            (StateCurrentPageIndex === RETRY_PAGE_INDEX) // ||
            // (StateCurrentPageIndex === SAVE_PAGE_INDEX) || // 2023-08-23 Jeff 修改成 存檔時 不修改CurrentPageIndex 避免不必要的空白頁面
            // (StateCurrentPageIndex === SUBMIT_PAGE_INDEX) // 2023-08-23 Jeff 修改成 存檔時 不修改CurrentPageIndex 避免不必要的空白頁面
            )
        {
            // console.log(COMP_NAME + "." + FUNC_NAME + " StateCurrentPageIndex:", StateCurrentPageIndex)
            return null
        }
        else
        {
            let objBlock = null
            if (props.LUInfo.SuperQuestion.length > 1)
            {
                console.log("Card.mintChangeAnimationType: ", mintChangeAnimationType)
                objBlock = (
                    <Card
                        CardIndex={StateCurrentPageIndex}
                        ChangeAnimationType={mintChangeAnimationType}
                        CallbackRef={CardCallback}
                        CardBackground={CardBackgroundEnum.GrayWithRadius}
                        RenderContent={RenderPageContent(StateCurrentPageIndex)}
                    />
                )
            }
            else if (props.LUInfo.SuperQuestion.length === 1)
            {
                objBlock = RenderPageContent(StateCurrentPageIndex)
            }

            return (
                <div className={cssCompositionContent.divContentArea} >
                    {objBlock}
                </div>
            )
        }
    } // end of RenderContentArea

    /*===========================================
    summary: Render 主畫面 的顯示
    remarks: 000 Tim 2022/01/07 Create
    ===========================================*/
    function RenderMainArea(StateCurrentPageIndex)
    {
        return (
            <>
                {RenderContentArea(StateCurrentPageIndex)}
                {RenderPageNumberIconArea(StateCurrentPageIndex)}
            </>
        )
    } // end of RenderMainArea

    return (
        <>
            {RenderMainArea(currentPageIndex)}
        </>
    )
    // #endregion Render
}
export default CompositionContent